var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { r as revive, _ as __vitePreload } from "./revive.min.03898b7d.js";
import "./modulepreload-polyfill.min.7faf532e.js";
import { S as Screen } from "./Screen.min.41307fbb.js";
import { C as Component } from "./Component.min.06c3b4f2.js";
import { D as Device } from "./Device.min.630865ee.js";
import "./cssVar.min.a83b954d.js";
import "./Emitter.min.eb356be5.js";
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x) {
  return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
function getAugmentedNamespace(n) {
  if (n.__esModule)
    return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a2() {
      if (this instanceof a2) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else
    a = {};
  Object.defineProperty(a, "__esModule", { value: true });
  Object.keys(n).forEach(function(k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function() {
        return n[k];
      }
    });
  });
  return a;
}
var lazysizes = { exports: {} };
(function(module) {
  (function(window2, factory) {
    var lazySizes2 = factory(window2, window2.document, Date);
    window2.lazySizes = lazySizes2;
    if (module.exports) {
      module.exports = lazySizes2;
    }
  })(
    typeof window != "undefined" ? window : {},
    /**
     * import("./types/global")
     * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
     */
    function l(window2, document2, Date2) {
      var lazysizes2, lazySizesCfg;
      (function() {
        var prop;
        var lazySizesDefaults = {
          lazyClass: "lazyload",
          loadedClass: "lazyloaded",
          loadingClass: "lazyloading",
          preloadClass: "lazypreload",
          errorClass: "lazyerror",
          //strictClass: 'lazystrict',
          autosizesClass: "lazyautosizes",
          fastLoadedClass: "ls-is-cached",
          iframeLoadMode: 0,
          srcAttr: "data-src",
          srcsetAttr: "data-srcset",
          sizesAttr: "data-sizes",
          //preloadAfterLoad: false,
          minSize: 40,
          customMedia: {},
          init: true,
          expFactor: 1.5,
          hFac: 0.8,
          loadMode: 2,
          loadHidden: true,
          ricTimeout: 0,
          throttleDelay: 125
        };
        lazySizesCfg = window2.lazySizesConfig || window2.lazysizesConfig || {};
        for (prop in lazySizesDefaults) {
          if (!(prop in lazySizesCfg)) {
            lazySizesCfg[prop] = lazySizesDefaults[prop];
          }
        }
      })();
      if (!document2 || !document2.getElementsByClassName) {
        return {
          init: function() {
          },
          /**
           * @type { LazySizesConfigPartial }
           */
          cfg: lazySizesCfg,
          /**
           * @type { true }
           */
          noSupport: true
        };
      }
      var docElem = document2.documentElement;
      var supportPicture = window2.HTMLPictureElement;
      var _addEventListener = "addEventListener";
      var _getAttribute = "getAttribute";
      var addEventListener2 = window2[_addEventListener].bind(window2);
      var setTimeout2 = window2.setTimeout;
      var requestAnimationFrame2 = window2.requestAnimationFrame || setTimeout2;
      var requestIdleCallback = window2.requestIdleCallback;
      var regPicture = /^picture$/i;
      var loadEvents = ["load", "error", "lazyincluded", "_lazyloaded"];
      var regClassCache = {};
      var forEach = Array.prototype.forEach;
      var hasClass = function(ele, cls) {
        if (!regClassCache[cls]) {
          regClassCache[cls] = new RegExp("(\\s|^)" + cls + "(\\s|$)");
        }
        return regClassCache[cls].test(ele[_getAttribute]("class") || "") && regClassCache[cls];
      };
      var addClass = function(ele, cls) {
        if (!hasClass(ele, cls)) {
          ele.setAttribute("class", (ele[_getAttribute]("class") || "").trim() + " " + cls);
        }
      };
      var removeClass = function(ele, cls) {
        var reg;
        if (reg = hasClass(ele, cls)) {
          ele.setAttribute("class", (ele[_getAttribute]("class") || "").replace(reg, " "));
        }
      };
      var addRemoveLoadEvents = function(dom, fn, add) {
        var action = add ? _addEventListener : "removeEventListener";
        if (add) {
          addRemoveLoadEvents(dom, fn);
        }
        loadEvents.forEach(function(evt) {
          dom[action](evt, fn);
        });
      };
      var triggerEvent = function(elem, name, detail, noBubbles, noCancelable) {
        var event = document2.createEvent("Event");
        if (!detail) {
          detail = {};
        }
        detail.instance = lazysizes2;
        event.initEvent(name, !noBubbles, !noCancelable);
        event.detail = detail;
        elem.dispatchEvent(event);
        return event;
      };
      var updatePolyfill = function(el, full) {
        var polyfill;
        if (!supportPicture && (polyfill = window2.picturefill || lazySizesCfg.pf)) {
          if (full && full.src && !el[_getAttribute]("srcset")) {
            el.setAttribute("srcset", full.src);
          }
          polyfill({ reevaluate: true, elements: [el] });
        } else if (full && full.src) {
          el.src = full.src;
        }
      };
      var getCSS = function(elem, style) {
        return (getComputedStyle(elem, null) || {})[style];
      };
      var getWidth = function(elem, parent, width) {
        width = width || elem.offsetWidth;
        while (width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth) {
          width = parent.offsetWidth;
          parent = parent.parentNode;
        }
        return width;
      };
      var rAF = function() {
        var running, waiting;
        var firstFns = [];
        var secondFns = [];
        var fns = firstFns;
        var run = function() {
          var runFns = fns;
          fns = firstFns.length ? secondFns : firstFns;
          running = true;
          waiting = false;
          while (runFns.length) {
            runFns.shift()();
          }
          running = false;
        };
        var rafBatch = function(fn, queue) {
          if (running && !queue) {
            fn.apply(this, arguments);
          } else {
            fns.push(fn);
            if (!waiting) {
              waiting = true;
              (document2.hidden ? setTimeout2 : requestAnimationFrame2)(run);
            }
          }
        };
        rafBatch._lsFlush = run;
        return rafBatch;
      }();
      var rAFIt = function(fn, simple) {
        return simple ? function() {
          rAF(fn);
        } : function() {
          var that = this;
          var args = arguments;
          rAF(function() {
            fn.apply(that, args);
          });
        };
      };
      var throttle = function(fn) {
        var running;
        var lastTime = 0;
        var gDelay = lazySizesCfg.throttleDelay;
        var rICTimeout = lazySizesCfg.ricTimeout;
        var run = function() {
          running = false;
          lastTime = Date2.now();
          fn();
        };
        var idleCallback = requestIdleCallback && rICTimeout > 49 ? function() {
          requestIdleCallback(run, { timeout: rICTimeout });
          if (rICTimeout !== lazySizesCfg.ricTimeout) {
            rICTimeout = lazySizesCfg.ricTimeout;
          }
        } : rAFIt(function() {
          setTimeout2(run);
        }, true);
        return function(isPriority) {
          var delay;
          if (isPriority = isPriority === true) {
            rICTimeout = 33;
          }
          if (running) {
            return;
          }
          running = true;
          delay = gDelay - (Date2.now() - lastTime);
          if (delay < 0) {
            delay = 0;
          }
          if (isPriority || delay < 9) {
            idleCallback();
          } else {
            setTimeout2(idleCallback, delay);
          }
        };
      };
      var debounce = function(func) {
        var timeout, timestamp;
        var wait = 99;
        var run = function() {
          timeout = null;
          func();
        };
        var later = function() {
          var last = Date2.now() - timestamp;
          if (last < wait) {
            setTimeout2(later, wait - last);
          } else {
            (requestIdleCallback || run)(run);
          }
        };
        return function() {
          timestamp = Date2.now();
          if (!timeout) {
            timeout = setTimeout2(later, wait);
          }
        };
      };
      var loader = function() {
        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;
        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;
        var regImg = /^img$/i;
        var regIframe = /^iframe$/i;
        var supportScroll = "onscroll" in window2 && !/(gle|ing)bot/.test(navigator.userAgent);
        var shrinkExpand = 0;
        var currentExpand = 0;
        var isLoading = 0;
        var lowRuns = -1;
        var resetPreloading = function(e) {
          isLoading--;
          if (!e || isLoading < 0 || !e.target) {
            isLoading = 0;
          }
        };
        var isVisible = function(elem) {
          if (isBodyHidden == null) {
            isBodyHidden = getCSS(document2.body, "visibility") == "hidden";
          }
          return isBodyHidden || !(getCSS(elem.parentNode, "visibility") == "hidden" && getCSS(elem, "visibility") == "hidden");
        };
        var isNestedVisible = function(elem, elemExpand) {
          var outerRect;
          var parent = elem;
          var visible = isVisible(elem);
          eLtop -= elemExpand;
          eLbottom += elemExpand;
          eLleft -= elemExpand;
          eLright += elemExpand;
          while (visible && (parent = parent.offsetParent) && parent != document2.body && parent != docElem) {
            visible = (getCSS(parent, "opacity") || 1) > 0;
            if (visible && getCSS(parent, "overflow") != "visible") {
              outerRect = parent.getBoundingClientRect();
              visible = eLright > outerRect.left && eLleft < outerRect.right && eLbottom > outerRect.top - 1 && eLtop < outerRect.bottom + 1;
            }
          }
          return visible;
        };
        var checkElements = function() {
          var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal, beforeExpandVal, defaultExpand, preloadExpand, hFac;
          var lazyloadElems = lazysizes2.elements;
          if ((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)) {
            i = 0;
            lowRuns++;
            for (; i < eLlen; i++) {
              if (!lazyloadElems[i] || lazyloadElems[i]._lazyRace) {
                continue;
              }
              if (!supportScroll || lazysizes2.prematureUnveil && lazysizes2.prematureUnveil(lazyloadElems[i])) {
                unveilElement(lazyloadElems[i]);
                continue;
              }
              if (!(elemExpandVal = lazyloadElems[i][_getAttribute]("data-expand")) || !(elemExpand = elemExpandVal * 1)) {
                elemExpand = currentExpand;
              }
              if (!defaultExpand) {
                defaultExpand = !lazySizesCfg.expand || lazySizesCfg.expand < 1 ? docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 : lazySizesCfg.expand;
                lazysizes2._defEx = defaultExpand;
                preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                hFac = lazySizesCfg.hFac;
                isBodyHidden = null;
                if (currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document2.hidden) {
                  currentExpand = preloadExpand;
                  lowRuns = 0;
                } else if (loadMode > 1 && lowRuns > 1 && isLoading < 6) {
                  currentExpand = defaultExpand;
                } else {
                  currentExpand = shrinkExpand;
                }
              }
              if (beforeExpandVal !== elemExpand) {
                eLvW = innerWidth + elemExpand * hFac;
                elvH = innerHeight + elemExpand;
                elemNegativeExpand = elemExpand * -1;
                beforeExpandVal = elemExpand;
              }
              rect = lazyloadElems[i].getBoundingClientRect();
              if ((eLbottom = rect.bottom) >= elemNegativeExpand && (eLtop = rect.top) <= elvH && (eLright = rect.right) >= elemNegativeExpand * hFac && (eLleft = rect.left) <= eLvW && (eLbottom || eLright || eLleft || eLtop) && (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) && (isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4) || isNestedVisible(lazyloadElems[i], elemExpand))) {
                unveilElement(lazyloadElems[i]);
                loadedSomething = true;
                if (isLoading > 9) {
                  break;
                }
              } else if (!loadedSomething && isCompleted && !autoLoadElem && isLoading < 4 && lowRuns < 4 && loadMode > 2 && (preloadElems[0] || lazySizesCfg.preloadAfterLoad) && (preloadElems[0] || !elemExpandVal && (eLbottom || eLright || eLleft || eLtop || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != "auto"))) {
                autoLoadElem = preloadElems[0] || lazyloadElems[i];
              }
            }
            if (autoLoadElem && !loadedSomething) {
              unveilElement(autoLoadElem);
            }
          }
        };
        var throttledCheckElements = throttle(checkElements);
        var switchLoadingClass = function(e) {
          var elem = e.target;
          if (elem._lazyCache) {
            delete elem._lazyCache;
            return;
          }
          resetPreloading(e);
          addClass(elem, lazySizesCfg.loadedClass);
          removeClass(elem, lazySizesCfg.loadingClass);
          addRemoveLoadEvents(elem, rafSwitchLoadingClass);
          triggerEvent(elem, "lazyloaded");
        };
        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
        var rafSwitchLoadingClass = function(e) {
          rafedSwitchLoadingClass({ target: e.target });
        };
        var changeIframeSrc = function(elem, src) {
          var loadMode2 = elem.getAttribute("data-load-mode") || lazySizesCfg.iframeLoadMode;
          if (loadMode2 == 0) {
            elem.contentWindow.location.replace(src);
          } else if (loadMode2 == 1) {
            elem.src = src;
          }
        };
        var handleSources = function(source) {
          var customMedia;
          var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);
          if (customMedia = lazySizesCfg.customMedia[source[_getAttribute]("data-media") || source[_getAttribute]("media")]) {
            source.setAttribute("media", customMedia);
          }
          if (sourceSrcset) {
            source.setAttribute("srcset", sourceSrcset);
          }
        };
        var lazyUnveil = rAFIt(function(elem, detail, isAuto, sizes, isImg) {
          var src, srcset, parent, isPicture, event, firesLoad;
          if (!(event = triggerEvent(elem, "lazybeforeunveil", detail)).defaultPrevented) {
            if (sizes) {
              if (isAuto) {
                addClass(elem, lazySizesCfg.autosizesClass);
              } else {
                elem.setAttribute("sizes", sizes);
              }
            }
            srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
            src = elem[_getAttribute](lazySizesCfg.srcAttr);
            if (isImg) {
              parent = elem.parentNode;
              isPicture = parent && regPicture.test(parent.nodeName || "");
            }
            firesLoad = detail.firesLoad || "src" in elem && (srcset || src || isPicture);
            event = { target: elem };
            addClass(elem, lazySizesCfg.loadingClass);
            if (firesLoad) {
              clearTimeout(resetPreloadingTimer);
              resetPreloadingTimer = setTimeout2(resetPreloading, 2500);
              addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
            }
            if (isPicture) {
              forEach.call(parent.getElementsByTagName("source"), handleSources);
            }
            if (srcset) {
              elem.setAttribute("srcset", srcset);
            } else if (src && !isPicture) {
              if (regIframe.test(elem.nodeName)) {
                changeIframeSrc(elem, src);
              } else {
                elem.src = src;
              }
            }
            if (isImg && (srcset || isPicture)) {
              updatePolyfill(elem, { src });
            }
          }
          if (elem._lazyRace) {
            delete elem._lazyRace;
          }
          removeClass(elem, lazySizesCfg.lazyClass);
          rAF(function() {
            var isLoaded = elem.complete && elem.naturalWidth > 1;
            if (!firesLoad || isLoaded) {
              if (isLoaded) {
                addClass(elem, lazySizesCfg.fastLoadedClass);
              }
              switchLoadingClass(event);
              elem._lazyCache = true;
              setTimeout2(function() {
                if ("_lazyCache" in elem) {
                  delete elem._lazyCache;
                }
              }, 9);
            }
            if (elem.loading == "lazy") {
              isLoading--;
            }
          }, true);
        });
        var unveilElement = function(elem) {
          if (elem._lazyRace) {
            return;
          }
          var detail;
          var isImg = regImg.test(elem.nodeName);
          var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]("sizes"));
          var isAuto = sizes == "auto";
          if ((isAuto || !isCompleted) && isImg && (elem[_getAttribute]("src") || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)) {
            return;
          }
          detail = triggerEvent(elem, "lazyunveilread").detail;
          if (isAuto) {
            autoSizer.updateElem(elem, true, elem.offsetWidth);
          }
          elem._lazyRace = true;
          isLoading++;
          lazyUnveil(elem, detail, isAuto, sizes, isImg);
        };
        var afterScroll = debounce(function() {
          lazySizesCfg.loadMode = 3;
          throttledCheckElements();
        });
        var altLoadmodeScrollListner = function() {
          if (lazySizesCfg.loadMode == 3) {
            lazySizesCfg.loadMode = 2;
          }
          afterScroll();
        };
        var onload = function() {
          if (isCompleted) {
            return;
          }
          if (Date2.now() - started < 999) {
            setTimeout2(onload, 999);
            return;
          }
          isCompleted = true;
          lazySizesCfg.loadMode = 3;
          throttledCheckElements();
          addEventListener2("scroll", altLoadmodeScrollListner, true);
        };
        return {
          _: function() {
            started = Date2.now();
            lazysizes2.elements = document2.getElementsByClassName(lazySizesCfg.lazyClass);
            preloadElems = document2.getElementsByClassName(lazySizesCfg.lazyClass + " " + lazySizesCfg.preloadClass);
            addEventListener2("scroll", throttledCheckElements, true);
            addEventListener2("resize", throttledCheckElements, true);
            addEventListener2("pageshow", function(e) {
              if (e.persisted) {
                var loadingElements = document2.querySelectorAll("." + lazySizesCfg.loadingClass);
                if (loadingElements.length && loadingElements.forEach) {
                  requestAnimationFrame2(function() {
                    loadingElements.forEach(function(img) {
                      if (img.complete) {
                        unveilElement(img);
                      }
                    });
                  });
                }
              }
            });
            if (window2.MutationObserver) {
              new MutationObserver(throttledCheckElements).observe(docElem, { childList: true, subtree: true, attributes: true });
            } else {
              docElem[_addEventListener]("DOMNodeInserted", throttledCheckElements, true);
              docElem[_addEventListener]("DOMAttrModified", throttledCheckElements, true);
              setInterval(throttledCheckElements, 999);
            }
            addEventListener2("hashchange", throttledCheckElements, true);
            ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(name) {
              document2[_addEventListener](name, throttledCheckElements, true);
            });
            if (/d$|^c/.test(document2.readyState)) {
              onload();
            } else {
              addEventListener2("load", onload);
              document2[_addEventListener]("DOMContentLoaded", throttledCheckElements);
              setTimeout2(onload, 2e4);
            }
            if (lazysizes2.elements.length) {
              checkElements();
              rAF._lsFlush();
            } else {
              throttledCheckElements();
            }
          },
          checkElems: throttledCheckElements,
          unveil: unveilElement,
          _aLSL: altLoadmodeScrollListner
        };
      }();
      var autoSizer = function() {
        var autosizesElems;
        var sizeElement = rAFIt(function(elem, parent, event, width) {
          var sources, i, len;
          elem._lazysizesWidth = width;
          width += "px";
          elem.setAttribute("sizes", width);
          if (regPicture.test(parent.nodeName || "")) {
            sources = parent.getElementsByTagName("source");
            for (i = 0, len = sources.length; i < len; i++) {
              sources[i].setAttribute("sizes", width);
            }
          }
          if (!event.detail.dataAttr) {
            updatePolyfill(elem, event.detail);
          }
        });
        var getSizeElement = function(elem, dataAttr, width) {
          var event;
          var parent = elem.parentNode;
          if (parent) {
            width = getWidth(elem, parent, width);
            event = triggerEvent(elem, "lazybeforesizes", { width, dataAttr: !!dataAttr });
            if (!event.defaultPrevented) {
              width = event.detail.width;
              if (width && width !== elem._lazysizesWidth) {
                sizeElement(elem, parent, event, width);
              }
            }
          }
        };
        var updateElementsSizes = function() {
          var i;
          var len = autosizesElems.length;
          if (len) {
            i = 0;
            for (; i < len; i++) {
              getSizeElement(autosizesElems[i]);
            }
          }
        };
        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);
        return {
          _: function() {
            autosizesElems = document2.getElementsByClassName(lazySizesCfg.autosizesClass);
            addEventListener2("resize", debouncedUpdateElementsSizes);
          },
          checkElems: debouncedUpdateElementsSizes,
          updateElem: getSizeElement
        };
      }();
      var init = function() {
        if (!init.i && document2.getElementsByClassName) {
          init.i = true;
          autoSizer._();
          loader._();
        }
      };
      setTimeout2(function() {
        if (lazySizesCfg.init) {
          init();
        }
      });
      lazysizes2 = {
        /**
         * @type { LazySizesConfigPartial }
         */
        cfg: lazySizesCfg,
        autoSizer,
        loader,
        init,
        uP: updatePolyfill,
        aC: addClass,
        rC: removeClass,
        hC: hasClass,
        fire: triggerEvent,
        gW: getWidth,
        rAF
      };
      return lazysizes2;
    }
  );
})(lazysizes);
var lazysizesExports = lazysizes.exports;
const lazySizes = /* @__PURE__ */ getDefaultExportFromCjs(lazysizesExports);
var ls_unveilhooks = { exports: {} };
(function(module) {
  (function(window2, factory) {
    var globalInstall = function() {
      factory(window2.lazySizes);
      window2.removeEventListener("lazyunveilread", globalInstall, true);
    };
    factory = factory.bind(null, window2, window2.document);
    if (module.exports) {
      factory(lazysizesExports);
    } else if (window2.lazySizes) {
      globalInstall();
    } else {
      window2.addEventListener("lazyunveilread", globalInstall, true);
    }
  })(window, function(window2, document2, lazySizes2) {
    var bgLoad, regBgUrlEscape;
    var uniqueUrls = {};
    if (document2.addEventListener) {
      regBgUrlEscape = /\(|\)|\s|'/;
      bgLoad = function(url, cb) {
        var img = document2.createElement("img");
        img.onload = function() {
          img.onload = null;
          img.onerror = null;
          img = null;
          cb();
        };
        img.onerror = img.onload;
        img.src = url;
        if (img && img.complete && img.onload) {
          img.onload();
        }
      };
      addEventListener("lazybeforeunveil", function(e) {
        if (e.detail.instance != lazySizes2) {
          return;
        }
        var tmp, load, bg, poster;
        if (!e.defaultPrevented) {
          var target = e.target;
          if (target.preload == "none") {
            target.preload = target.getAttribute("data-preload") || "auto";
          }
          if (target.getAttribute("data-autoplay") != null) {
            if (target.getAttribute("data-expand") && !target.autoplay) {
              try {
                target.play();
              } catch (er) {
              }
            } else {
              requestAnimationFrame(function() {
                target.setAttribute("data-expand", "-10");
                lazySizes2.aC(target, lazySizes2.cfg.lazyClass);
              });
            }
          }
          tmp = target.getAttribute("data-link");
          if (tmp) {
            addStyleScript(tmp, true);
          }
          tmp = target.getAttribute("data-script");
          if (tmp) {
            e.detail.firesLoad = true;
            load = function() {
              e.detail.firesLoad = false;
              lazySizes2.fire(target, "_lazyloaded", {}, true, true);
            };
            addStyleScript(tmp, null, load);
          }
          tmp = target.getAttribute("data-require");
          if (tmp) {
            if (lazySizes2.cfg.requireJs) {
              lazySizes2.cfg.requireJs([tmp]);
            } else {
              addStyleScript(tmp);
            }
          }
          bg = target.getAttribute("data-bg");
          if (bg) {
            e.detail.firesLoad = true;
            load = function() {
              target.style.backgroundImage = "url(" + (regBgUrlEscape.test(bg) ? JSON.stringify(bg) : bg) + ")";
              e.detail.firesLoad = false;
              lazySizes2.fire(target, "_lazyloaded", {}, true, true);
            };
            bgLoad(bg, load);
          }
          poster = target.getAttribute("data-poster");
          if (poster) {
            e.detail.firesLoad = true;
            load = function() {
              target.poster = poster;
              e.detail.firesLoad = false;
              lazySizes2.fire(target, "_lazyloaded", {}, true, true);
            };
            bgLoad(poster, load);
          }
        }
      }, false);
    }
    function addStyleScript(src, style, cb) {
      if (uniqueUrls[src]) {
        return;
      }
      var elem = document2.createElement(style ? "link" : "script");
      var insertElem = document2.getElementsByTagName("script")[0];
      if (style) {
        elem.rel = "stylesheet";
        elem.href = src;
      } else {
        elem.onload = function() {
          elem.onerror = null;
          elem.onload = null;
          cb();
        };
        elem.onerror = elem.onload;
        elem.src = src;
      }
      uniqueUrls[src] = true;
      uniqueUrls[elem.src || elem.href] = true;
      insertElem.parentNode.insertBefore(elem, insertElem);
    }
  });
})(ls_unveilhooks);
var ls_attrchange = { exports: {} };
(function(module) {
  (function(window2, factory) {
    if (!window2) {
      return;
    }
    var globalInstall = function() {
      factory(window2.lazySizes);
      window2.removeEventListener("lazyunveilread", globalInstall, true);
    };
    factory = factory.bind(null, window2, window2.document);
    if (module.exports) {
      factory(lazysizesExports);
    } else if (window2.lazySizes) {
      globalInstall();
    } else {
      window2.addEventListener("lazyunveilread", globalInstall, true);
    }
  })(typeof window != "undefined" ? window : 0, function(window2, document2, lazySizes2) {
    var addObserver = function() {
      var connect, disconnect, observer, connected;
      var lsCfg = lazySizes2.cfg;
      var attributes = { "data-bgset": 1, "data-include": 1, "data-poster": 1, "data-bg": 1, "data-script": 1 };
      var regClassTest = "(\\s|^)(" + lsCfg.loadedClass;
      var docElem = document2.documentElement;
      var setClass = function(target) {
        lazySizes2.rAF(function() {
          lazySizes2.rC(target, lsCfg.loadedClass);
          if (lsCfg.unloadedClass) {
            lazySizes2.rC(target, lsCfg.unloadedClass);
          }
          lazySizes2.aC(target, lsCfg.lazyClass);
          if (target.style.display == "none" || target.parentNode && target.parentNode.style.display == "none") {
            setTimeout(function() {
              lazySizes2.loader.unveil(target);
            }, 0);
          }
        });
      };
      var onMutation = function(mutations) {
        var i, len, mutation, target;
        for (i = 0, len = mutations.length; i < len; i++) {
          mutation = mutations[i];
          target = mutation.target;
          if (!target.getAttribute(mutation.attributeName)) {
            continue;
          }
          if (target.localName == "source" && target.parentNode) {
            target = target.parentNode.querySelector("img");
          }
          if (target && regClassTest.test(target.className)) {
            setClass(target);
          }
        }
      };
      if (lsCfg.unloadedClass) {
        regClassTest += "|" + lsCfg.unloadedClass;
      }
      regClassTest += "|" + lsCfg.loadingClass + ")(\\s|$)";
      regClassTest = new RegExp(regClassTest);
      attributes[lsCfg.srcAttr] = 1;
      attributes[lsCfg.srcsetAttr] = 1;
      if (window2.MutationObserver) {
        observer = new MutationObserver(onMutation);
        connect = function() {
          if (!connected) {
            connected = true;
            observer.observe(docElem, { subtree: true, attributes: true, attributeFilter: Object.keys(attributes) });
          }
        };
        disconnect = function() {
          if (connected) {
            connected = false;
            observer.disconnect();
          }
        };
      } else {
        docElem.addEventListener("DOMAttrModified", function() {
          var runs;
          var modifications = [];
          var callMutations = function() {
            onMutation(modifications);
            modifications = [];
            runs = false;
          };
          return function(e) {
            if (connected && attributes[e.attrName] && e.newValue) {
              modifications.push({ target: e.target, attributeName: e.attrName });
              if (!runs) {
                setTimeout(callMutations);
                runs = true;
              }
            }
          };
        }(), true);
        connect = function() {
          connected = true;
        };
        disconnect = function() {
          connected = false;
        };
      }
      addEventListener("lazybeforeunveil", disconnect, true);
      addEventListener("lazybeforeunveil", connect);
      addEventListener("lazybeforesizes", disconnect, true);
      addEventListener("lazybeforesizes", connect);
      connect();
      removeEventListener("lazybeforeunveil", addObserver);
    };
    addEventListener("lazybeforeunveil", addObserver);
  });
})(ls_attrchange);
var ls_respimg = { exports: {} };
(function(module) {
  (function(window2, factory) {
    if (!window2) {
      return;
    }
    var globalInstall = function() {
      factory(window2.lazySizes);
      window2.removeEventListener("lazyunveilread", globalInstall, true);
    };
    factory = factory.bind(null, window2, window2.document);
    if (module.exports) {
      factory(lazysizesExports);
    } else if (window2.lazySizes) {
      globalInstall();
    } else {
      window2.addEventListener("lazyunveilread", globalInstall, true);
    }
  })(typeof window != "undefined" ? window : 0, function(window2, document2, lazySizes2) {
    var polyfill;
    var lazySizesCfg = lazySizes2.cfg;
    var img = document2.createElement("img");
    var supportSrcset = "sizes" in img && "srcset" in img;
    var regHDesc = /\s+\d+h/g;
    var fixEdgeHDescriptor = function() {
      var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
      var forEach = Array.prototype.forEach;
      return function() {
        var img2 = document2.createElement("img");
        var removeHDescriptors = function(source) {
          var ratio, match;
          var srcset = source.getAttribute(lazySizesCfg.srcsetAttr);
          if (srcset) {
            if (match = srcset.match(regDescriptors)) {
              if (match[2] == "w") {
                ratio = match[1] / match[3];
              } else {
                ratio = match[3] / match[1];
              }
              if (ratio) {
                source.setAttribute("data-aspectratio", ratio);
              }
              source.setAttribute(lazySizesCfg.srcsetAttr, srcset.replace(regHDesc, ""));
            }
          }
        };
        var handler = function(e) {
          if (e.detail.instance != lazySizes2) {
            return;
          }
          var picture = e.target.parentNode;
          if (picture && picture.nodeName == "PICTURE") {
            forEach.call(picture.getElementsByTagName("source"), removeHDescriptors);
          }
          removeHDescriptors(e.target);
        };
        var test = function() {
          if (!!img2.currentSrc) {
            document2.removeEventListener("lazybeforeunveil", handler);
          }
        };
        document2.addEventListener("lazybeforeunveil", handler);
        img2.onload = test;
        img2.onerror = test;
        img2.srcset = "data:,a 1w 1h";
        if (img2.complete) {
          test();
        }
      };
    }();
    if (!lazySizesCfg.supportsType) {
      lazySizesCfg.supportsType = function(type) {
        return !type;
      };
    }
    if (window2.HTMLPictureElement && supportSrcset) {
      if (!lazySizes2.hasHDescriptorFix && document2.msElementsFromPoint) {
        lazySizes2.hasHDescriptorFix = true;
        fixEdgeHDescriptor();
      }
      return;
    }
    if (window2.picturefill || lazySizesCfg.pf) {
      return;
    }
    lazySizesCfg.pf = function(options) {
      var i, len;
      if (window2.picturefill) {
        return;
      }
      for (i = 0, len = options.elements.length; i < len; i++) {
        polyfill(options.elements[i]);
      }
    };
    polyfill = function() {
      var ascendingSort = function(a, b) {
        return a.w - b.w;
      };
      var regPxLength = /^\s*\d+\.*\d*px\s*$/;
      var reduceCandidate = function(srces) {
        var lowerCandidate, bonusFactor;
        var len = srces.length;
        var candidate = srces[len - 1];
        var i = 0;
        for (i; i < len; i++) {
          candidate = srces[i];
          candidate.d = candidate.w / srces.w;
          if (candidate.d >= srces.d) {
            if (!candidate.cached && (lowerCandidate = srces[i - 1]) && lowerCandidate.d > srces.d - 0.13 * Math.pow(srces.d, 2.2)) {
              bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);
              if (lowerCandidate.cached) {
                lowerCandidate.d += 0.15 * bonusFactor;
              }
              if (lowerCandidate.d + (candidate.d - srces.d) * bonusFactor > srces.d) {
                candidate = lowerCandidate;
              }
            }
            break;
          }
        }
        return candidate;
      };
      var parseWsrcset = function() {
        var candidates;
        var regWCandidates = /(([^,\s].[^\s]+)\s+(\d+)w)/g;
        var regMultiple = /\s/;
        var addCandidate = function(match, candidate, url, wDescriptor) {
          candidates.push({
            c: candidate,
            u: url,
            w: wDescriptor * 1
          });
        };
        return function(input) {
          candidates = [];
          input = input.trim();
          input.replace(regHDesc, "").replace(regWCandidates, addCandidate);
          if (!candidates.length && input && !regMultiple.test(input)) {
            candidates.push({
              c: input,
              u: input,
              w: 99
            });
          }
          return candidates;
        };
      }();
      var runMatchMedia = function() {
        if (runMatchMedia.init) {
          return;
        }
        runMatchMedia.init = true;
        addEventListener("resize", function() {
          var timer;
          var matchMediaElems = document2.getElementsByClassName("lazymatchmedia");
          var run = function() {
            var i, len;
            for (i = 0, len = matchMediaElems.length; i < len; i++) {
              polyfill(matchMediaElems[i]);
            }
          };
          return function() {
            clearTimeout(timer);
            timer = setTimeout(run, 66);
          };
        }());
      };
      var createSrcset = function(elem, isImage) {
        var parsedSet;
        var srcSet = elem.getAttribute("srcset") || elem.getAttribute(lazySizesCfg.srcsetAttr);
        if (!srcSet && isImage) {
          srcSet = !elem._lazypolyfill ? elem.getAttribute(lazySizesCfg.srcAttr) || elem.getAttribute("src") : elem._lazypolyfill._set;
        }
        if (!elem._lazypolyfill || elem._lazypolyfill._set != srcSet) {
          parsedSet = parseWsrcset(srcSet || "");
          if (isImage && elem.parentNode) {
            parsedSet.isPicture = elem.parentNode.nodeName.toUpperCase() == "PICTURE";
            if (parsedSet.isPicture) {
              if (window2.matchMedia) {
                lazySizes2.aC(elem, "lazymatchmedia");
                runMatchMedia();
              }
            }
          }
          parsedSet._set = srcSet;
          Object.defineProperty(elem, "_lazypolyfill", {
            value: parsedSet,
            writable: true
          });
        }
      };
      var getX = function(elem) {
        var dpr = window2.devicePixelRatio || 1;
        var optimum = lazySizes2.getX && lazySizes2.getX(elem);
        return Math.min(optimum || dpr, 2.5, dpr);
      };
      var matchesMedia = function(media) {
        if (window2.matchMedia) {
          matchesMedia = function(media2) {
            return !media2 || (matchMedia(media2) || {}).matches;
          };
        } else {
          return !media;
        }
        return matchesMedia(media);
      };
      var getCandidate = function(elem) {
        var sources, i, len, source, srces, src, width;
        source = elem;
        createSrcset(source, true);
        srces = source._lazypolyfill;
        if (srces.isPicture) {
          for (i = 0, sources = elem.parentNode.getElementsByTagName("source"), len = sources.length; i < len; i++) {
            if (lazySizesCfg.supportsType(sources[i].getAttribute("type"), elem) && matchesMedia(sources[i].getAttribute("media"))) {
              source = sources[i];
              createSrcset(source);
              srces = source._lazypolyfill;
              break;
            }
          }
        }
        if (srces.length > 1) {
          width = source.getAttribute("sizes") || "";
          width = regPxLength.test(width) && parseInt(width, 10) || lazySizes2.gW(elem, elem.parentNode);
          srces.d = getX(elem);
          if (!srces.src || !srces.w || srces.w < width) {
            srces.w = width;
            src = reduceCandidate(srces.sort(ascendingSort));
            srces.src = src;
          } else {
            src = srces.src;
          }
        } else {
          src = srces[0];
        }
        return src;
      };
      var p = function(elem) {
        if (supportSrcset && elem.parentNode && elem.parentNode.nodeName.toUpperCase() != "PICTURE") {
          return;
        }
        var candidate = getCandidate(elem);
        if (candidate && candidate.u && elem._lazypolyfill.cur != candidate.u) {
          elem._lazypolyfill.cur = candidate.u;
          candidate.cached = true;
          elem.setAttribute(lazySizesCfg.srcAttr, candidate.u);
          elem.setAttribute("src", candidate.u);
        }
      };
      p.parse = parseWsrcset;
      return p;
    }();
    if (lazySizesCfg.loadedClass && lazySizesCfg.loadingClass) {
      (function() {
        var sels = [];
        ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(sel) {
          sels.push(sel + lazySizesCfg.loadedClass);
          sels.push(sel + lazySizesCfg.loadingClass);
        });
        lazySizesCfg.pf({
          elements: document2.querySelectorAll(sels.join(", "))
        });
      })();
    }
  });
})(ls_respimg);
var ls_nativeLoading = { exports: {} };
(function(module) {
  (function(window2, factory) {
    var globalInstall = function() {
      factory(window2.lazySizes);
      window2.removeEventListener("lazyunveilread", globalInstall, true);
    };
    factory = factory.bind(null, window2, window2.document);
    if (module.exports) {
      factory(lazysizesExports);
    } else if (window2.lazySizes) {
      globalInstall();
    } else {
      window2.addEventListener("lazyunveilread", globalInstall, true);
    }
  })(window, function(window2, document2, lazySizes2) {
    var imgSupport = "loading" in HTMLImageElement.prototype;
    var iframeSupport = "loading" in HTMLIFrameElement.prototype;
    var isConfigSet = false;
    var oldPrematureUnveil = lazySizes2.prematureUnveil;
    var cfg = lazySizes2.cfg;
    var listenerMap = {
      focus: 1,
      mouseover: 1,
      click: 1,
      load: 1,
      transitionend: 1,
      animationend: 1,
      scroll: 1,
      resize: 1
    };
    if (!cfg.nativeLoading) {
      cfg.nativeLoading = {};
    }
    if (!window2.addEventListener || !window2.MutationObserver || !imgSupport && !iframeSupport) {
      return;
    }
    function disableEvents() {
      var loader = lazySizes2.loader;
      var throttledCheckElements = loader.checkElems;
      var removeALSL = function() {
        setTimeout(function() {
          window2.removeEventListener("scroll", loader._aLSL, true);
        }, 1e3);
      };
      var currentListenerMap = typeof cfg.nativeLoading.disableListeners == "object" ? cfg.nativeLoading.disableListeners : listenerMap;
      if (currentListenerMap.scroll) {
        window2.addEventListener("load", removeALSL);
        removeALSL();
        window2.removeEventListener("scroll", throttledCheckElements, true);
      }
      if (currentListenerMap.resize) {
        window2.removeEventListener("resize", throttledCheckElements, true);
      }
      Object.keys(currentListenerMap).forEach(function(name) {
        if (currentListenerMap[name]) {
          document2.removeEventListener(name, throttledCheckElements, true);
        }
      });
    }
    function runConfig() {
      if (isConfigSet) {
        return;
      }
      isConfigSet = true;
      if (imgSupport && iframeSupport && cfg.nativeLoading.disableListeners) {
        if (cfg.nativeLoading.disableListeners === true) {
          cfg.nativeLoading.setLoadingAttribute = true;
        }
        disableEvents();
      }
      if (cfg.nativeLoading.setLoadingAttribute) {
        window2.addEventListener("lazybeforeunveil", function(e) {
          var element = e.target;
          if ("loading" in element && !element.getAttribute("loading")) {
            element.setAttribute("loading", "lazy");
          }
        }, true);
      }
    }
    lazySizes2.prematureUnveil = function prematureUnveil(element) {
      if (!isConfigSet) {
        runConfig();
      }
      if ("loading" in element && (cfg.nativeLoading.setLoadingAttribute || element.getAttribute("loading")) && (element.getAttribute("data-sizes") != "auto" || element.offsetWidth)) {
        return true;
      }
      if (oldPrematureUnveil) {
        return oldPrematureUnveil(element);
      }
    };
  });
})(ls_nativeLoading);
const theme = "";
const _Notif = class _Notif {
  constructor({ id, html, onRemove }) {
    this.id = id;
    this.html = html;
    this.elRemove = this.html.querySelector(_Notif.selectors.elRemove);
    this.onRemove = onRemove;
    this._autoRemoveTimer = null;
    this.isRemoving = false;
    this.isWishlist = this.html.classList.contains("wishlist-notif-container") || !!this.html.querySelector(".wishlist-notif-container");
    this.isAtc = this.html.classList.contains("atc-notif-container") || !!this.html.querySelector(".atc-notif-container");
    this.delay = this.isWishlist ? _Notif.delays.wishlist : _Notif.delays.cart;
    this.active();
    this.bindEvents();
  }
  getWishlistContainer() {
    if (this.html.classList.contains("wishlist-notif-container")) {
      return this.html;
    }
    return this.html.querySelector(".wishlist-notif-container");
  }
  getAtcContainer() {
    if (this.html.classList.contains("atc-notif-container")) {
      return this.html;
    }
    return this.html.querySelector(".atc-notif-container");
  }
  bindEvents() {
    if (this.elRemove) {
      this.elRemove.addEventListener("click", this.remove.bind(this, true));
    }
  }
  active() {
    if (Device.isReduced)
      return false;
    this._autoRemoveTimer = setTimeout(() => {
      this.remove();
    }, this.delay);
  }
  async remove(force = false) {
    if (this.isRemoving)
      return false;
    if (this.isActiveElement() && !force) {
      this._autoRemoveTimer = setTimeout(() => {
        this.remove();
      }, this.delay);
      return false;
    }
    this.isRemoving = true;
    clearTimeout(this._autoRemoveTimer);
    if (this.isWishlist) {
      const wishlistContainer = this.getWishlistContainer();
      if (wishlistContainer) {
        wishlistContainer.classList.remove("is-visible", "is-repositioning", "is-animating", "is-entering");
        void wishlistContainer.offsetHeight;
        wishlistContainer.classList.add("is-removing");
        await new Promise((resolve) => setTimeout(resolve, 400));
      }
    }
    if (this.isAtc) {
      const atcContainer = this.getAtcContainer();
      if (atcContainer) {
        atcContainer.classList.remove("is-visible", "is-repositioning", "is-entering");
        void atcContainer.offsetHeight;
        atcContainer.classList.add("is-removing");
        await new Promise((resolve) => setTimeout(resolve, 450));
      }
    }
    this.onRemove(this.id);
  }
  isActiveElement() {
    return this.html.matches(":hover");
  }
};
__publicField(_Notif, "delays", {
  cart: 5e5,
  wishlist: 3e3
});
__publicField(_Notif, "selectors", {
  elRemove: "[data-notif-remove]"
});
let Notif = _Notif;
const _NotificationsManager = class _NotificationsManager extends Component {
  onInit() {
    this.el = document.querySelector(_NotificationsManager.selectors.el);
    this.notifs = [];
    this._pendingIds = /* @__PURE__ */ new Set();
    this._recentContentHashes = /* @__PURE__ */ new Map();
    this._overlay = null;
    this._headerBlocker = null;
  }
  _getContentHash(html) {
    const el = html.cloneNode(true);
    el.removeAttribute("data-notif-index");
    el.removeAttribute("tabindex");
    el.removeAttribute("role");
    el.removeAttribute("aria-live");
    return el.innerHTML.trim();
  }
  _isRecentDuplicate(html) {
    const hash = this._getContentHash(html);
    const now = Date.now();
    const DEBOUNCE_MS = 1e3;
    for (const [key, timestamp] of this._recentContentHashes) {
      if (now - timestamp > DEBOUNCE_MS) {
        this._recentContentHashes.delete(key);
      }
    }
    if (this._recentContentHashes.has(hash)) {
      return true;
    }
    this._recentContentHashes.set(hash, now);
    return false;
  }
  /**
   * Returns the active AB variant ('a' or 'b').
   * Default is 'a' (old). AB Tasty sets 'b' via body class.
   */
  getActiveVariant() {
    return document.body.classList.contains("ab-cart-notif-b") ? "b" : "a";
  }
  /**
   * Activates the correct variant inside a notification element
   * and removes the inactive one so only one set of [data-notif-remove] exists.
   */
  activateVariant(html) {
    const variant = this.getActiveVariant();
    const activeSelector = `.ab-variant--${variant}`;
    const inactiveSelector = variant === "a" ? ".ab-variant--b" : ".ab-variant--a";
    const activeEl = html.querySelector(activeSelector);
    const inactiveEl = html.querySelector(inactiveSelector);
    if (activeEl) {
      activeEl.style.display = "";
    }
    if (inactiveEl) {
      inactiveEl.remove();
    }
  }
  register(notification = {}) {
    if (this.isNotifIdExisted(notification.id) || this._pendingIds.has(notification.id)) {
      console.warn(`Notification avec l'ID "${notification.id}" existe déjà.`);
      return;
    }
    if (this._isRecentDuplicate(notification.html)) {
      console.warn(`Duplicate notification content blocked (ID: "${notification.id}").`);
      return;
    }
    this._pendingIds.add(notification.id);
    this.activateVariant(notification.html);
    const isWishlist = this.isWishlistNotification(notification.html);
    const isAtc = this.isAtcNotification(notification.html);
    const sameTypeNotifs = this.notifs.filter((n) => n.isWishlist === isWishlist);
    if (sameTypeNotifs.length >= _NotificationsManager.MAX_NOTIFICATIONS_PER_TYPE) {
      const oldestNotif = sameTypeNotifs[0];
      oldestNotif.remove(true);
    }
    const _Notif2 = new Notif({
      id: notification.id,
      html: notification.html,
      onRemove: this.onRemove.bind(this)
    });
    _Notif2.isWishlist = isWishlist;
    _Notif2.isAtc = isAtc;
    _Notif2.html.setAttribute("role", "alert");
    _Notif2.html.setAttribute("aria-live", "assertive");
    _Notif2.html.setAttribute("tabindex", "0");
    const triggerElement = document.activeElement;
    _Notif2.html.dataset.triggerElement = triggerElement ? `[data-id="${triggerElement.dataset.id}"]` : null;
    this.prepareRepositioning(isWishlist);
    this.notifs.push(_Notif2);
    this._pendingIds.delete(notification.id);
    this.renderNotification(_Notif2);
    this.updatePositions(isWishlist);
    this.setFocus(_Notif2);
  }
  isWishlistNotification(html) {
    if (html.classList && html.classList.contains("wishlist-notif-container")) {
      return true;
    }
    return !!html.querySelector(".wishlist-notif-container");
  }
  isAtcNotification(html) {
    if (html.classList && html.classList.contains("atc-notif-container")) {
      return true;
    }
    return !!html.querySelector(".atc-notif-container");
  }
  getWishlistContainer(html) {
    if (html.classList && html.classList.contains("wishlist-notif-container")) {
      return html;
    }
    return html.querySelector(".wishlist-notif-container");
  }
  getAtcContainer(html) {
    if (html.classList && html.classList.contains("atc-notif-container")) {
      return html;
    }
    return html.querySelector(".atc-notif-container");
  }
  prepareRepositioning(isWishlist) {
    this.notifs.filter((n) => n.isWishlist === isWishlist).forEach((notif) => {
      const wishlistContainer = this.getWishlistContainer(notif.html);
      if (wishlistContainer && wishlistContainer.classList.contains("is-visible")) {
        wishlistContainer.classList.add("is-repositioning");
      }
      const atcContainer = this.getAtcContainer(notif.html);
      if (atcContainer && atcContainer.classList.contains("is-visible")) {
        atcContainer.classList.add("is-repositioning");
      }
    });
  }
  // =========================================
  // Overlay & Header Blocker (variant B only)
  // =========================================
  showOverlay() {
    if (this._overlay)
      return;
    this._headerBlocker = document.createElement("div");
    this._headerBlocker.classList.add("atc-notif-header-blocker");
    document.body.appendChild(this._headerBlocker);
    this._overlay = document.createElement("div");
    this._overlay.classList.add("atc-notif-overlay", "is-entering");
    document.body.appendChild(this._overlay);
    void this._overlay.offsetHeight;
    this._overlay.classList.remove("is-entering");
    this._overlay.classList.add("is-visible");
    this._overlay.addEventListener("click", () => {
      this.removeCartNotifications();
    });
  }
  hideOverlay() {
    if (!this._overlay)
      return;
    this._overlay.classList.remove("is-visible");
    this._overlay.classList.add("is-removing");
    setTimeout(() => {
      if (this._overlay) {
        this._overlay.remove();
        this._overlay = null;
      }
      if (this._headerBlocker) {
        this._headerBlocker.remove();
        this._headerBlocker = null;
      }
    }, 400);
  }
  /**
   * Remove all cart (non-wishlist) notifications.
   * Called when clicking the overlay.
   */
  removeCartNotifications() {
    const cartNotifs = this.notifs.filter((n) => !n.isWishlist);
    cartNotifs.forEach((notif) => notif.remove(true));
  }
  /**
   * Check if any cart notifications with atc-notif-container are still active.
   * Used to determine whether overlay should stay visible.
   */
  hasActiveAtcNotifications() {
    return this.notifs.some((n) => n.isAtc);
  }
  onRemove(id) {
    var _a;
    const index = this.notifs.findIndex((notif) => notif.id === id);
    const currentNotif = this.notifs[index];
    if (currentNotif == null)
      return false;
    const { html } = currentNotif;
    const isWishlist = currentNotif.isWishlist;
    const triggerElement = html.dataset.triggerElement;
    if (triggerElement) {
      (_a = document.querySelector(triggerElement)) == null ? void 0 : _a.focus();
    }
    html.remove();
    this.notifs.splice(index, 1);
    this._pendingIds.delete(id);
    this.updatePositions(isWishlist);
    if (!this.hasActiveAtcNotifications()) {
      this.hideOverlay();
    }
  }
  renderNotification(notif) {
    const wishlistContainer = this.getWishlistContainer(notif.html);
    const atcContainer = this.getAtcContainer(notif.html);
    if (wishlistContainer) {
      wishlistContainer.classList.add("is-entering");
    }
    if (atcContainer) {
      atcContainer.classList.add("is-entering");
      this.showOverlay();
    }
    this.el.insertBefore(notif.html, this.el.firstChild);
    if (wishlistContainer) {
      void wishlistContainer.offsetHeight;
      wishlistContainer.classList.remove("is-entering");
      wishlistContainer.classList.add("is-animating");
      void wishlistContainer.offsetHeight;
      requestAnimationFrame(() => {
        wishlistContainer.classList.add("is-visible");
        setTimeout(() => {
          wishlistContainer.classList.remove("is-animating");
          this.clearRepositioning(notif.isWishlist);
        }, 450);
      });
    }
    if (atcContainer) {
      void atcContainer.offsetHeight;
      atcContainer.classList.remove("is-entering");
      void atcContainer.offsetHeight;
      requestAnimationFrame(() => {
        atcContainer.classList.add("is-visible");
        setTimeout(() => {
          this.clearRepositioning(notif.isWishlist);
        }, 450);
      });
    }
  }
  updatePositions(isWishlist) {
    const typeNotifs = this.notifs.filter((n) => n.isWishlist === isWishlist);
    const sorted = [...typeNotifs].reverse();
    sorted.forEach((notif, index) => {
      notif.html.setAttribute("data-notif-index", index);
    });
    this.prepareRepositioning(isWishlist);
    setTimeout(() => {
      this.clearRepositioning(isWishlist);
    }, 400);
  }
  clearRepositioning(isWishlist) {
    this.notifs.filter((n) => n.isWishlist === isWishlist).forEach((notif) => {
      const wishlistContainer = this.getWishlistContainer(notif.html);
      if (wishlistContainer) {
        wishlistContainer.classList.remove("is-repositioning");
      }
      const atcContainer = this.getAtcContainer(notif.html);
      if (atcContainer) {
        atcContainer.classList.remove("is-repositioning");
      }
    });
  }
  isNotifIdExisted(id) {
    return !!this.notifs.find((notif) => notif.id === id);
  }
  setFocus(notif) {
    const { html } = notif;
    const elFocusables = html.querySelectorAll("a, button, input, textarea, select");
    if (elFocusables.length) {
      elFocusables[0].focus();
    } else {
      html.focus();
    }
  }
};
__publicField(_NotificationsManager, "selectors", {
  el: '[data-component="notifications-manager"]'
});
__publicField(_NotificationsManager, "MAX_NOTIFICATIONS_PER_TYPE", 3);
let NotificationsManager = _NotificationsManager;
const NotificationsManager$1 = new NotificationsManager();
class CartNotification {
  constructor() {
    this._initStackingFix();
    this._initOverlayDismiss();
    this._initClampObserver();
  }
  // =========================================
  // Render ATC notification
  // =========================================
  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      NotificationsManager$1.register({
        id: `${this.cartItemKey}_${(/* @__PURE__ */ new Date()).valueOf()}`,
        html: this.getSectionHtml(parsedState.sections[section.id], section.selector)
      });
    });
  }
  getSectionsToRender() {
    return [
      {
        id: "cart-notification-product",
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`
      }
    ];
  }
  getSectionHtml(html, selector = ".shopify-section") {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }
  // =========================================
  // Move ATC items to body to escape container stacking context
  // =========================================
  _initStackingFix() {
    const notificationsManager = document.querySelector('[data-component="notifications-manager"]');
    if (!notificationsManager)
      return;
    const moveAtcItems = () => {
      notificationsManager.querySelectorAll(".c-notifications__item:has(.atc-notif-container)").forEach((item) => {
        if (item.parentElement !== document.body) {
          document.body.appendChild(item);
        }
      });
    };
    this._stackingObserver = new MutationObserver(moveAtcItems);
    this._stackingObserver.observe(notificationsManager, { childList: true });
  }
  // =========================================
  // Dismiss notifications when clicking overlay or header blocker
  // =========================================
  _initOverlayDismiss() {
    document.addEventListener("click", (e) => {
      if (e.target.classList.contains("atc-notif-header-blocker") || e.target.classList.contains("atc-notif-overlay")) {
        document.querySelectorAll(".atc-notif-container.is-visible [data-notif-remove]").forEach((btn) => btn.click());
      }
    });
  }
  // =========================================
  // Adjust title clamping based on subtitle height
  // =========================================
  _initClampObserver() {
    const adjustClamp = () => {
      document.querySelectorAll(".atc-notif-container").forEach((container) => {
        const subtitle = container.querySelector(".surtitle.text-header");
        const title = container.querySelector(".text-title.surtitle");
        if (!subtitle || !title)
          return;
        const lineHeight = parseFloat(getComputedStyle(subtitle).lineHeight);
        const isTwoLines = subtitle.scrollHeight > lineHeight * 1.5;
        title.classList.toggle("--clamp-2", isTwoLines);
      });
    };
    this._clampObserver = new MutationObserver(adjustClamp);
    this._clampObserver.observe(document.body, { childList: true, subtree: true });
  }
  // =========================================
  // Cleanup
  // =========================================
  destroy() {
    var _a, _b;
    (_a = this._stackingObserver) == null ? void 0 : _a.disconnect();
    (_b = this._clampObserver) == null ? void 0 : _b.disconnect();
  }
}
const CartNotification$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: CartNotification
}, Symbol.toStringTag, { value: "Module" }));
const _CartCounter = class _CartCounter {
  constructor() {
    this.cartCount = document.querySelector(_CartCounter.selector.cart_count);
    this.cartCountMobile = document.querySelector(_CartCounter.selector.cart_count_mobile);
    this.cartCountDesktop = document.querySelector(_CartCounter.selector.cart_count_desktop);
    this.counter = parseInt(this.cartCountDesktop.querySelector("span").innerText);
  }
  updateCounters() {
    this.counter++;
    this.updateCartCounter(this.counter);
    this.updateCartCounterMobile(this.counter);
    this.updateCartCounterDesktop(this.counter);
  }
  updateCartCounter(counter) {
    this.cartCount.querySelector(".counter").innerText = `(${counter})`;
  }
  updateCartCounterMobile(counter) {
    const span = this.cartCountMobile.querySelector("span");
    span.innerText = counter;
    span.dataset.state = "";
  }
  updateCartCounterDesktop(counter) {
    const span = this.cartCountDesktop.querySelector("span");
    span.innerText = counter;
    span.dataset.state = "";
  }
};
__publicField(_CartCounter, "selector", {
  cart_count: "#cart-count",
  cart_count_mobile: "#cart-count-mobile",
  cart_count_desktop: "#cart-count-desktop"
});
let CartCounter = _CartCounter;
const CartCounter$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: CartCounter
}, Symbol.toStringTag, { value: "Module" }));
const _WishlistNotification = class _WishlistNotification extends Component {
  onInit() {
    this.cartNotif = new CartNotification();
    this.cartCounter = new CartCounter();
    this.handlers = {
      add: this.onAddItem.bind(this),
      remove: this.onRemoveItem.bind(this),
      cart: this.cartAddItem.bind(this)
    };
    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener("wishlist-add-item", this.handlers.add);
    document.addEventListener("wishlist-remove-item", this.handlers.remove);
    document.addEventListener("cart-add-item", this.handlers.cart);
  }
  async cartAddItem(event) {
    this.cartCounter.updateCounters();
    this.cartNotif.renderContents(event.detail);
  }
  async onAddItem(event) {
    if (!event.detail || !event.detail.product)
      return;
    const { product } = event.detail;
    const handle = product.productHandle || product.handle;
    if (!handle)
      return;
    await this.registerNotification(handle, product, "add");
  }
  async onRemoveItem(event) {
    if (!event.detail || !event.detail.product)
      return;
    const { product } = event.detail;
    const handle = product.productHandle || product.handle;
    if (!handle)
      return;
    await this.registerNotification(handle, product, "remove");
  }
  async registerNotification(handle, product, action = "add") {
    const titleText = action === "add" ? window.wishlistStrings.add_title : window.wishlistStrings.remove_title;
    const textLinkWishlist = window.wishlistStrings.access_wishlist;
    try {
      const html = await _WishlistNotification.getHtml(handle);
      if (!html)
        return;
      const img = html.querySelector("img");
      if (img && img.src) {
        html.style.position = "absolute";
        html.style.left = "-9999px";
        html.style.visibility = "hidden";
        document.body.appendChild(html);
        await new Promise((resolve) => {
          if (img.complete && img.naturalHeight > 0) {
            resolve();
          } else {
            img.onload = resolve;
            img.onerror = resolve;
          }
        });
        html.remove();
        html.style.position = "";
        html.style.left = "";
        html.style.visibility = "";
      }
      const id = _WishlistNotification.generateRandomId();
      html.id = id;
      const title = html.querySelector(_WishlistNotification.selectors.title);
      if (title) {
        title.innerHTML = titleText;
      }
      const linkWishlist = html.querySelector(_WishlistNotification.selectors.linkWishlist);
      if (linkWishlist) {
        linkWishlist.innerHTML = textLinkWishlist;
      }
      NotificationsManager$1.register({ id, html });
    } catch (error) {
      console.error(error);
    }
  }
  static generateRandomId() {
    return `wishlist-notification-${Date.now()}-${Math.floor(Math.random() * 1e4)}`;
  }
  static async getHtml(handle) {
    try {
      const res = await fetch(_WishlistNotification.url(handle));
      if (!res.ok)
        return null;
      const text = await res.text();
      return _WishlistNotification.parseHtml(text, _WishlistNotification.selectors.el);
    } catch (error) {
      return null;
    }
  }
  static parseHtml(html, selector) {
    return new DOMParser().parseFromString(html, "text/html").querySelector(selector);
  }
};
__publicField(_WishlistNotification, "selectors", {
  title: ".wishlist-notif-header-item p",
  linkWishlist: '[data-slot="link-wishlist"] span',
  el: ".wishlist-notif-container"
});
__publicField(_WishlistNotification, "url", (handle) => `${Shopify.routes.root}products/${handle}?view=wishlist-notification`);
let WishlistNotification = _WishlistNotification;
const WishlistNotification$1 = new WishlistNotification();
const _Breadcrumb = class _Breadcrumb extends Component {
  onInit() {
    var _a;
    this.breadcrumb = this.getBreadcrumb();
    this.pageType = (_a = document.querySelector(_Breadcrumb.selector.page_type)) == null ? void 0 : _a.className;
    const allowedPages = ["collection", "wrapper-product"];
    const isOnThePage = this.pageType && allowedPages.includes(this.pageType) ? true : false;
    if (!isOnThePage || !this.breadcrumb) {
      this.breadcrumb = _Breadcrumb.breadcrumb_empty;
    }
    if (isOnThePage) {
      if (this.checkChangeInLocale()) {
        this.updateLabelWithLocale();
      }
      this.handleBackButton();
      this.render();
    }
    this.bindEvent();
  }
  autoFillBreadcrumb() {
    var _a, _b, _c, _d;
    const breadcrumb = this.breadcrumb || { ..._Breadcrumb.breadcrumb_empty };
    const level0El = document.querySelector(_Breadcrumb.selector.item_level_0_elements + " a");
    if (level0El) {
      breadcrumb.level_0.href = level0El.href;
      breadcrumb.level_0.label = ((_a = level0El.querySelector("span")) == null ? void 0 : _a.textContent.trim()) || "";
    }
    const level1El = document.querySelector(_Breadcrumb.selector.item_level_1_elements + " a");
    if (level1El) {
      breadcrumb.level_1.href = level1El.href;
      breadcrumb.level_1.label = ((_b = level1El.querySelector("span")) == null ? void 0 : _b.textContent.trim()) || "";
    }
    const level2El = document.querySelector(_Breadcrumb.selector.item_level_2_elements + " a");
    if (level2El) {
      breadcrumb.level_2.href = level2El.href;
      breadcrumb.level_2.label = ((_c = level2El.querySelector("span")) == null ? void 0 : _c.textContent.trim()) || "";
    }
    const level3El = document.querySelector(_Breadcrumb.selector.card_media + " a");
    if (level3El) {
      breadcrumb.level_3.href = level3El.href;
      breadcrumb.level_3.label = ((_d = level3El.querySelector(".title")) == null ? void 0 : _d.textContent.trim()) || "";
    }
    this.breadcrumb = breadcrumb;
    this.saveBreadcrumb(this.breadcrumb);
  }
  bindEvent() {
    document.querySelectorAll(_Breadcrumb.selector.item_level_0_elements).forEach((element) => element.addEventListener("click", this.handleLevel0Click.bind(this)));
    document.querySelectorAll(_Breadcrumb.selector.item_level_1_elements).forEach((element) => element.addEventListener("click", this.handleLevel1Click.bind(this)));
    document.querySelectorAll(_Breadcrumb.selector.item_level_2_elements).forEach((element) => element.addEventListener("click", this.handleLevel2Click.bind(this)));
    document.querySelectorAll(_Breadcrumb.selector.breadcrumb_list_element).forEach((element) => element.addEventListener("click", this.handleBreadcrumbClick.bind(this)));
    document.querySelectorAll(_Breadcrumb.selector.card_media).forEach((element) => element.addEventListener("click", this.handleMediaClick.bind(this)));
  }
  render() {
    const breadcrumbList = document.querySelector(_Breadcrumb.selector.breadcrumb_list);
    const breadcrumb = this.breadcrumb;
    console.log("this.breadcrumb", this.breadcrumb);
    const createBreadcrumbItem = (level, index) => {
      var _a, _b;
      if (((_a = breadcrumb[level]) == null ? void 0 : _a.href) && ((_b = breadcrumb[level]) == null ? void 0 : _b.label)) {
        const li = document.createElement("li");
        li.setAttribute("level", level);
        const a = document.createElement("a");
        a.href = breadcrumb[level].href;
        const span = document.createElement("span");
        span.textContent = breadcrumb[level].label;
        console.log("breadcrumb[level]", breadcrumb[level]);
        console.log("breadcrumb[level].label", breadcrumb[level].label);
        console.log("------------");
        li.appendChild(a).appendChild(span);
        breadcrumbList.insertBefore(li, breadcrumbList.querySelectorAll("li")[index + 1]);
      }
    };
    createBreadcrumbItem("level_0", 0);
    createBreadcrumbItem("level_1", 1);
    createBreadcrumbItem("level_2", 2);
    createBreadcrumbItem("level_3", 3);
  }
  checkChangeInLocale() {
    const homeLocale = this.getLocale(document.querySelector('[level="home"] > a').href);
    const level0Locale = this.getLocale(this.breadcrumb.level_0.href);
    return level0Locale === homeLocale ? false : true;
  }
  getLocale(url) {
    if (!url)
      return "";
    const regex = /https:\/\/[^\/]+?\.[a-zA-Z]{2,}[\/]?([a-z]{2}(?:-[a-z]{2})?)?(?=[\/?]|$)/;
    return url.match(regex)[1] ? url.match(regex)[1] || "" : "";
  }
  updateLabelWithLocale() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
    const breadcrumb = this.breadcrumb;
    const homeLocale = this.getLocale(((_a = document.querySelector(_Breadcrumb.selector.home_url)) == null ? void 0 : _a.href) || "");
    console.log("=== DEBUG START ===");
    console.log("homeLocale:", homeLocale);
    console.log("breadcrumb BEFORE:", JSON.stringify(breadcrumb, null, 2));
    const normalizePath = (url) => {
      if (!url)
        return "";
      try {
        const urlObj = new URL(url);
        return urlObj.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/, "");
      } catch {
        return url;
      }
    };
    if (breadcrumb.level_0.href && breadcrumb.level_0.label) {
      const targetPath = normalizePath(breadcrumb.level_0.href);
      console.log("Level 0 - Looking for path:", targetPath);
      const navigationMenu = document.querySelector('.c-nav__list[data-variant="center"]');
      if (navigationMenu) {
        const allNavLinks = navigationMenu.querySelectorAll('li[role="menuitem"] a');
        console.log("Found navigation links:", allNavLinks.length);
        const matchingLink = Array.from(allNavLinks).find((anchor) => {
          const anchorPath = normalizePath(anchor.href);
          return anchorPath === targetPath;
        });
        console.log("Matched link:", matchingLink);
        if (matchingLink) {
          const spanText = (_c = (_b = matchingLink.querySelector("span")) == null ? void 0 : _b.textContent) == null ? void 0 : _c.trim();
          const collectionLabel = (_d = matchingLink.parentElement) == null ? void 0 : _d.getAttribute("collection-label");
          breadcrumb.level_0.label = collectionLabel || spanText || breadcrumb.level_0.label;
          console.log("Updated level_0 label to:", breadcrumb.level_0.label);
        }
      }
      const updatedUrl = new URL(this.updateUrlWithLocale(breadcrumb.level_0.href, homeLocale));
      breadcrumb.level_0.href = updatedUrl.origin + updatedUrl.pathname;
    }
    if (breadcrumb.level_1.href && breadcrumb.level_1.label) {
      const targetPath = normalizePath(breadcrumb.level_1.href);
      const allNavLinks = document.querySelectorAll(`${_Breadcrumb.selector.item_level_1_elements} a, .c-nav-tab__submenu a`);
      const matchingLink = Array.from(allNavLinks).find((anchor) => {
        const anchorPath = normalizePath(anchor.href);
        return anchorPath === targetPath;
      });
      if (matchingLink) {
        const collectionLabel = (_e = matchingLink.parentElement) == null ? void 0 : _e.getAttribute("collection-label");
        if (collectionLabel) {
          breadcrumb.level_1.label = collectionLabel;
        } else {
          const navTabCol = matchingLink.closest(".c-nav-tab__col");
          if (navTabCol) {
            const titleSpan = navTabCol.querySelector(".c-nav-tab__title > span");
            if (titleSpan) {
              breadcrumb.level_1.label = titleSpan.textContent.trim();
            }
          } else {
            const spanText = (_g = (_f = matchingLink.querySelector("span")) == null ? void 0 : _f.textContent) == null ? void 0 : _g.trim();
            if (spanText) {
              breadcrumb.level_1.label = spanText;
            }
          }
        }
      }
      const updatedUrl = new URL(this.updateUrlWithLocale(breadcrumb.level_1.href, homeLocale));
      breadcrumb.level_1.href = updatedUrl.origin + updatedUrl.pathname;
    }
    if (breadcrumb.level_2.href && breadcrumb.level_2.label) {
      const targetPath = normalizePath(breadcrumb.level_2.href);
      const allNavLinks = document.querySelectorAll(`${_Breadcrumb.selector.item_level_2_elements} a`);
      const matchingLink = Array.from(allNavLinks).find((anchor) => {
        const anchorPath = normalizePath(anchor.href);
        return anchorPath === targetPath;
      });
      if (matchingLink) {
        const spanText = (_i = (_h = matchingLink.querySelector("span")) == null ? void 0 : _h.textContent) == null ? void 0 : _i.trim();
        if (spanText) {
          breadcrumb.level_2.label = spanText;
        }
      }
      const updatedUrl = new URL(this.updateUrlWithLocale(breadcrumb.level_2.href, homeLocale));
      breadcrumb.level_2.href = updatedUrl.origin + updatedUrl.pathname;
    }
    if (breadcrumb.level_3.href && breadcrumb.level_3.label) {
      const targetPath = normalizePath(breadcrumb.level_3.href);
      const allMediaLinks = document.querySelectorAll(`${_Breadcrumb.selector.card_media} a`);
      const matchingLink = Array.from(allMediaLinks).find((anchor) => {
        const anchorPath = normalizePath(anchor.href);
        return anchorPath === targetPath;
      });
      if (matchingLink) {
        const titleText = (_k = (_j = matchingLink.querySelector(".title")) == null ? void 0 : _j.textContent) == null ? void 0 : _k.trim();
        if (titleText) {
          breadcrumb.level_3.label = titleText;
        }
      }
      const updatedUrl = new URL(this.updateUrlWithLocale(breadcrumb.level_3.href, homeLocale));
      breadcrumb.level_3.href = updatedUrl.origin + updatedUrl.pathname;
    }
    this.breadcrumb = breadcrumb;
    console.log("breadcrumb AFTER:", JSON.stringify(this.breadcrumb, null, 2));
    console.log("=== DEBUG END ===");
  }
  handleBackButton() {
    let breadcrumb = this.breadcrumb;
    const currentUrl = window.location.origin + window.location.pathname;
    let matchedLevel = null;
    for (const [key, value] of Object.entries(breadcrumb)) {
      if (value.href === currentUrl) {
        matchedLevel = key;
        break;
      }
    }
    if (matchedLevel) {
      let found = false;
      for (const key of Object.keys(breadcrumb)) {
        if (found) {
          breadcrumb[key] = { href: "", label: "" };
        }
        if (key === matchedLevel) {
          found = true;
        }
      }
    }
    this.breadcrumb = breadcrumb;
  }
  updateUrlWithLocale(url, locale) {
    const regex = /(https:\/\/[^\/]+)(\/[a-z]{2}(?:-[a-z]{2})?)?(\/.*)/;
    const match = url.match(regex);
    if (!match)
      return url;
    const [, domain, currentLocale, path] = match;
    if (locale === "") {
      return `${domain}${path}`;
    }
    if (currentLocale) {
      return `${domain}/${locale}${path}`;
    } else {
      return `${domain}/${locale}${path}`;
    }
  }
  handleLevel0Click(event) {
    event.preventDefault();
    const breadcrumb = _Breadcrumb.breadcrumb_empty;
    const link = event.currentTarget.querySelector("a");
    const button = event.currentTarget.querySelector("button");
    if (link) {
      breadcrumb.level_0.href = link.href;
      breadcrumb.level_0.label = link.querySelector("span").textContent.trim();
      this.breadcrumb = breadcrumb;
      this.saveBreadcrumb(this.breadcrumb);
      window.location.href = breadcrumb.level_0.href;
      return;
    } else if (button) {
      const tabsLevel0 = button.getAttribute("aria-controls");
      const divs = document.querySelectorAll(`section[id=${tabsLevel0}] > .c-nav-tab__inner > .c-nav-tab__col`);
      const fullDiv = Array.from(divs).find((div) => div.getAttribute("data-variant") === "full");
      if (fullDiv) {
        breadcrumb.level_0.href = fullDiv.querySelector("a").href;
        breadcrumb.level_0.label = button.querySelector("span").textContent.trim();
        this.breadcrumb = breadcrumb;
      } else {
        breadcrumb.level_0.href = "";
        breadcrumb.level_0.label = button.querySelector("span").textContent.trim();
        this.breadcrumb = breadcrumb;
      }
    }
  }
  handleLevel1Click(event) {
    var _a, _b;
    event.preventDefault();
    const breadcrumb = this.breadcrumb;
    if (!breadcrumb)
      return;
    const targetDiv = event.currentTarget;
    if (targetDiv.getAttribute("data-variant")) {
      breadcrumb.level_0.href = targetDiv.querySelector("a").href ? targetDiv.querySelector("a").href : "";
      breadcrumb.level_0.label = targetDiv.getAttribute("collection-label").trim();
      this.breadcrumb = breadcrumb;
      this.saveBreadcrumb(this.breadcrumb);
      window.location.href = breadcrumb.level_0.href;
      return;
    }
    const tabsLevel1 = targetDiv.querySelector(".c-nav-tab__title").getAttribute("data-nav-tabs-open");
    const lis = document.querySelectorAll(`.c-nav-tab__submenu[data-id=${tabsLevel1}] > .l-flow > li`);
    const selectedLi = Array.from(lis).find((li) => li.classList.contains("text"));
    if (selectedLi) {
      breadcrumb.level_1.href = selectedLi.querySelector("a").href ? selectedLi.querySelector("a").href : "";
      breadcrumb.level_1.label = (_a = targetDiv.querySelector(".c-nav-tab__title > span")) == null ? void 0 : _a.textContent.trim();
      this.breadcrumb = breadcrumb;
      this.saveBreadcrumb(this.breadcrumb);
    } else {
      breadcrumb.level_1.href = "";
      breadcrumb.level_1.label = (_b = targetDiv.querySelector(".c-nav-tab__title > span")) == null ? void 0 : _b.textContent.trim();
      this.breadcrumb = breadcrumb;
      this.saveBreadcrumb(this.breadcrumb);
    }
  }
  handleLevel2Click(event) {
    event.preventDefault();
    const breadcrumb = this.breadcrumb;
    if (!breadcrumb)
      return;
    const liElement = event.currentTarget;
    if (liElement.classList.contains("text")) {
      breadcrumb.level_1.href = liElement.querySelector("a").href;
      breadcrumb.level_1.label = liElement.getAttribute("collection-label").trim();
      this.breadcrumb = breadcrumb;
      this.saveBreadcrumb(this.breadcrumb);
      window.location.href = breadcrumb.level_1.href;
      return;
    }
    const link = liElement.querySelector("a");
    if (link) {
      breadcrumb.level_2.href = link.href;
      breadcrumb.level_2.label = link.querySelector("span").textContent.trim();
      this.breadcrumb = breadcrumb;
      this.saveBreadcrumb(this.breadcrumb);
      window.location.href = breadcrumb.level_2.href;
      return;
    }
  }
  handleBreadcrumbClick(event) {
    var _a, _b, _c;
    event.preventDefault();
    let breadcrumb = this.breadcrumb;
    switch (event.currentTarget.getAttribute("level")) {
      case "home":
        this.breadcrumb = _Breadcrumb.breadcrumb_empty;
        this.saveBreadcrumb(this.breadcrumb);
        window.location.href = event.currentTarget.querySelector("a").href;
        break;
      case "level_0":
        breadcrumb = { ..._Breadcrumb.breadcrumb_empty };
        breadcrumb.level_0.href = event.currentTarget.querySelector("a").href;
        breadcrumb.level_0.label = event.currentTarget.querySelector("a > span").textContent;
        this.breadcrumb = breadcrumb;
        this.saveBreadcrumb(this.breadcrumb);
        window.location.href = breadcrumb.level_0.href;
        break;
      case "level_1":
        breadcrumb.level_2 = { href: "", label: "" };
        breadcrumb.level_3 = { href: "", label: "" };
        this.breadcrumb = breadcrumb;
        this.saveBreadcrumb(this.breadcrumb);
        window.location.href = ((_a = breadcrumb.level_1) == null ? void 0 : _a.href) || "/";
        break;
      case "level_2":
        breadcrumb.level_3 = { href: "", label: "" };
        this.saveBreadcrumb(this.breadcrumb);
        window.location.href = ((_b = breadcrumb.level_2) == null ? void 0 : _b.href) || "/";
        break;
      case "level_3":
        this.saveBreadcrumb(this.breadcrumb);
        window.location.href = ((_c = breadcrumb.level_3) == null ? void 0 : _c.href) || "/";
      case "product":
        break;
      default:
        console.warn("Niveau de breadcrumb non reconnu :", event.currentTarget.getAttribute("level"));
    }
  }
  handleMediaClick(event) {
    var _a, _b;
    const link = event.target.closest("a");
    if (!link)
      return;
    event.preventDefault();
    let breadcrumb = this.breadcrumb;
    const href = link.href;
    if (this.pageType === "homepage") {
      const label = ((_a = link.querySelector("p")) == null ? void 0 : _a.textContent) || "";
      breadcrumb = { ..._Breadcrumb.breadcrumb_empty };
      breadcrumb.level_0.href = href;
      breadcrumb.level_0.label = label;
      this.breadcrumb = breadcrumb;
      this.saveBreadcrumb(this.breadcrumb);
      window.location.href = breadcrumb.level_0.href;
    } else {
      const label = ((_b = link.querySelector(".title")) == null ? void 0 : _b.textContent) || "";
      breadcrumb.level_3.href = href;
      breadcrumb.level_3.label = label;
      this.breadcrumb = breadcrumb;
      this.saveBreadcrumb(this.breadcrumb);
      window.location.href = breadcrumb.level_3.href;
    }
  }
  getBreadcrumb() {
    return JSON.parse(sessionStorage.getItem(_Breadcrumb.localStorage.breadcrumb));
  }
  saveBreadcrumb(breadcrumb) {
    sessionStorage.setItem(_Breadcrumb.localStorage.breadcrumb, JSON.stringify(breadcrumb));
  }
};
__publicField(_Breadcrumb, "localStorage", {
  breadcrumb: "breadcrumb"
});
__publicField(_Breadcrumb, "selector", {
  breadcrumb_list: "#breadcrumb > ol",
  breadcrumb_list_element: "#breadcrumb > ol > li",
  home_url: '[level="home"] > a',
  navigation_first_level: ".c-nav-tab__col",
  page_type: "main",
  item_level_0_elements: '.c-nav__list[data-variant="center"] > li',
  item_level_1_elements: ".c-nav-tab__inner > .c-nav-tab__col",
  item_level_2_elements: ".c-nav-tab__submenu .l-flow > li",
  card_media: ".c-card-media"
});
__publicField(_Breadcrumb, "breadcrumb_empty", {
  level_0: { href: "", label: "" },
  level_1: { href: "", label: "" },
  level_2: { href: "", label: "" },
  level_3: { href: "", label: "" }
});
let Breadcrumb = _Breadcrumb;
const Breadcrumb$1 = new Breadcrumb();
const Breadcrumb$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Breadcrumb$1
}, Symbol.toStringTag, { value: "Module" }));
var sha256 = { exports: {} };
const __viteBrowserExternal = new Proxy({}, {
  get(_, key) {
    throw new Error(`Module "" has been externalized for browser compatibility. Cannot access ".${key}" in client code.  See http://vitejs.dev/guide/troubleshooting.html#module-externalized-for-browser-compatibility for more details.`);
  }
});
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$1 = /* @__PURE__ */ getAugmentedNamespace(__viteBrowserExternal$1);
/**
 * [js-sha256]{@link https://github.com/emn178/js-sha256}
 *
 * @version 0.11.1
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2025
 * @license MIT
 */
(function(module) {
  (function() {
    var ERROR = "input is invalid type";
    var WINDOW = typeof window === "object";
    var root = WINDOW ? window : {};
    if (root.JS_SHA256_NO_WINDOW) {
      WINDOW = false;
    }
    var WEB_WORKER = !WINDOW && typeof self === "object";
    var NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node && process.type != "renderer";
    if (NODE_JS) {
      root = commonjsGlobal;
    } else if (WEB_WORKER) {
      root = self;
    }
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && true && module.exports;
    var ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer !== "undefined";
    var HEX_CHARS = "0123456789abcdef".split("");
    var EXTRA = [-2147483648, 8388608, 32768, 128];
    var SHIFT = [24, 16, 8, 0];
    var K = [
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ];
    var OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"];
    var blocks = [];
    if (root.JS_SHA256_NO_NODE_JS || !Array.isArray) {
      Array.isArray = function(obj) {
        return Object.prototype.toString.call(obj) === "[object Array]";
      };
    }
    if (ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView)) {
      ArrayBuffer.isView = function(obj) {
        return typeof obj === "object" && obj.buffer && obj.buffer.constructor === ArrayBuffer;
      };
    }
    var createOutputMethod = function(outputType, is224) {
      return function(message) {
        return new Sha256(is224, true).update(message)[outputType]();
      };
    };
    var createMethod = function(is224) {
      var method = createOutputMethod("hex", is224);
      if (NODE_JS) {
        method = nodeWrap(method, is224);
      }
      method.create = function() {
        return new Sha256(is224);
      };
      method.update = function(message) {
        return method.create().update(message);
      };
      for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
        var type = OUTPUT_TYPES[i];
        method[type] = createOutputMethod(type, is224);
      }
      return method;
    };
    var nodeWrap = function(method, is224) {
      var crypto = require$$1;
      var Buffer2 = require$$1.Buffer;
      var algorithm = is224 ? "sha224" : "sha256";
      var bufferFrom;
      if (Buffer2.from && !root.JS_SHA256_NO_BUFFER_FROM) {
        bufferFrom = Buffer2.from;
      } else {
        bufferFrom = function(message) {
          return new Buffer2(message);
        };
      }
      var nodeMethod = function(message) {
        if (typeof message === "string") {
          return crypto.createHash(algorithm).update(message, "utf8").digest("hex");
        } else {
          if (message === null || message === void 0) {
            throw new Error(ERROR);
          } else if (message.constructor === ArrayBuffer) {
            message = new Uint8Array(message);
          }
        }
        if (Array.isArray(message) || ArrayBuffer.isView(message) || message.constructor === Buffer2) {
          return crypto.createHash(algorithm).update(bufferFrom(message)).digest("hex");
        } else {
          return method(message);
        }
      };
      return nodeMethod;
    };
    var createHmacOutputMethod = function(outputType, is224) {
      return function(key, message) {
        return new HmacSha256(key, is224, true).update(message)[outputType]();
      };
    };
    var createHmacMethod = function(is224) {
      var method = createHmacOutputMethod("hex", is224);
      method.create = function(key) {
        return new HmacSha256(key, is224);
      };
      method.update = function(key, message) {
        return method.create(key).update(message);
      };
      for (var i = 0; i < OUTPUT_TYPES.length; ++i) {
        var type = OUTPUT_TYPES[i];
        method[type] = createHmacOutputMethod(type, is224);
      }
      return method;
    };
    function Sha256(is224, sharedMemory) {
      if (sharedMemory) {
        blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        this.blocks = blocks;
      } else {
        this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
      }
      if (is224) {
        this.h0 = 3238371032;
        this.h1 = 914150663;
        this.h2 = 812702999;
        this.h3 = 4144912697;
        this.h4 = 4290775857;
        this.h5 = 1750603025;
        this.h6 = 1694076839;
        this.h7 = 3204075428;
      } else {
        this.h0 = 1779033703;
        this.h1 = 3144134277;
        this.h2 = 1013904242;
        this.h3 = 2773480762;
        this.h4 = 1359893119;
        this.h5 = 2600822924;
        this.h6 = 528734635;
        this.h7 = 1541459225;
      }
      this.block = this.start = this.bytes = this.hBytes = 0;
      this.finalized = this.hashed = false;
      this.first = true;
      this.is224 = is224;
    }
    Sha256.prototype.update = function(message) {
      if (this.finalized) {
        return;
      }
      var notString, type = typeof message;
      if (type !== "string") {
        if (type === "object") {
          if (message === null) {
            throw new Error(ERROR);
          } else if (ARRAY_BUFFER && message.constructor === ArrayBuffer) {
            message = new Uint8Array(message);
          } else if (!Array.isArray(message)) {
            if (!ARRAY_BUFFER || !ArrayBuffer.isView(message)) {
              throw new Error(ERROR);
            }
          }
        } else {
          throw new Error(ERROR);
        }
        notString = true;
      }
      var code, index = 0, i, length = message.length, blocks2 = this.blocks;
      while (index < length) {
        if (this.hashed) {
          this.hashed = false;
          blocks2[0] = this.block;
          this.block = blocks2[16] = blocks2[1] = blocks2[2] = blocks2[3] = blocks2[4] = blocks2[5] = blocks2[6] = blocks2[7] = blocks2[8] = blocks2[9] = blocks2[10] = blocks2[11] = blocks2[12] = blocks2[13] = blocks2[14] = blocks2[15] = 0;
        }
        if (notString) {
          for (i = this.start; index < length && i < 64; ++index) {
            blocks2[i >>> 2] |= message[index] << SHIFT[i++ & 3];
          }
        } else {
          for (i = this.start; index < length && i < 64; ++index) {
            code = message.charCodeAt(index);
            if (code < 128) {
              blocks2[i >>> 2] |= code << SHIFT[i++ & 3];
            } else if (code < 2048) {
              blocks2[i >>> 2] |= (192 | code >>> 6) << SHIFT[i++ & 3];
              blocks2[i >>> 2] |= (128 | code & 63) << SHIFT[i++ & 3];
            } else if (code < 55296 || code >= 57344) {
              blocks2[i >>> 2] |= (224 | code >>> 12) << SHIFT[i++ & 3];
              blocks2[i >>> 2] |= (128 | code >>> 6 & 63) << SHIFT[i++ & 3];
              blocks2[i >>> 2] |= (128 | code & 63) << SHIFT[i++ & 3];
            } else {
              code = 65536 + ((code & 1023) << 10 | message.charCodeAt(++index) & 1023);
              blocks2[i >>> 2] |= (240 | code >>> 18) << SHIFT[i++ & 3];
              blocks2[i >>> 2] |= (128 | code >>> 12 & 63) << SHIFT[i++ & 3];
              blocks2[i >>> 2] |= (128 | code >>> 6 & 63) << SHIFT[i++ & 3];
              blocks2[i >>> 2] |= (128 | code & 63) << SHIFT[i++ & 3];
            }
          }
        }
        this.lastByteIndex = i;
        this.bytes += i - this.start;
        if (i >= 64) {
          this.block = blocks2[16];
          this.start = i - 64;
          this.hash();
          this.hashed = true;
        } else {
          this.start = i;
        }
      }
      if (this.bytes > 4294967295) {
        this.hBytes += this.bytes / 4294967296 << 0;
        this.bytes = this.bytes % 4294967296;
      }
      return this;
    };
    Sha256.prototype.finalize = function() {
      if (this.finalized) {
        return;
      }
      this.finalized = true;
      var blocks2 = this.blocks, i = this.lastByteIndex;
      blocks2[16] = this.block;
      blocks2[i >>> 2] |= EXTRA[i & 3];
      this.block = blocks2[16];
      if (i >= 56) {
        if (!this.hashed) {
          this.hash();
        }
        blocks2[0] = this.block;
        blocks2[16] = blocks2[1] = blocks2[2] = blocks2[3] = blocks2[4] = blocks2[5] = blocks2[6] = blocks2[7] = blocks2[8] = blocks2[9] = blocks2[10] = blocks2[11] = blocks2[12] = blocks2[13] = blocks2[14] = blocks2[15] = 0;
      }
      blocks2[14] = this.hBytes << 3 | this.bytes >>> 29;
      blocks2[15] = this.bytes << 3;
      this.hash();
    };
    Sha256.prototype.hash = function() {
      var a = this.h0, b = this.h1, c = this.h2, d = this.h3, e = this.h4, f = this.h5, g = this.h6, h = this.h7, blocks2 = this.blocks, j, s0, s1, maj, t1, t2, ch, ab, da, cd, bc;
      for (j = 16; j < 64; ++j) {
        t1 = blocks2[j - 15];
        s0 = (t1 >>> 7 | t1 << 25) ^ (t1 >>> 18 | t1 << 14) ^ t1 >>> 3;
        t1 = blocks2[j - 2];
        s1 = (t1 >>> 17 | t1 << 15) ^ (t1 >>> 19 | t1 << 13) ^ t1 >>> 10;
        blocks2[j] = blocks2[j - 16] + s0 + blocks2[j - 7] + s1 << 0;
      }
      bc = b & c;
      for (j = 0; j < 64; j += 4) {
        if (this.first) {
          if (this.is224) {
            ab = 300032;
            t1 = blocks2[0] - 1413257819;
            h = t1 - 150054599 << 0;
            d = t1 + 24177077 << 0;
          } else {
            ab = 704751109;
            t1 = blocks2[0] - 210244248;
            h = t1 - 1521486534 << 0;
            d = t1 + 143694565 << 0;
          }
          this.first = false;
        } else {
          s0 = (a >>> 2 | a << 30) ^ (a >>> 13 | a << 19) ^ (a >>> 22 | a << 10);
          s1 = (e >>> 6 | e << 26) ^ (e >>> 11 | e << 21) ^ (e >>> 25 | e << 7);
          ab = a & b;
          maj = ab ^ a & c ^ bc;
          ch = e & f ^ ~e & g;
          t1 = h + s1 + ch + K[j] + blocks2[j];
          t2 = s0 + maj;
          h = d + t1 << 0;
          d = t1 + t2 << 0;
        }
        s0 = (d >>> 2 | d << 30) ^ (d >>> 13 | d << 19) ^ (d >>> 22 | d << 10);
        s1 = (h >>> 6 | h << 26) ^ (h >>> 11 | h << 21) ^ (h >>> 25 | h << 7);
        da = d & a;
        maj = da ^ d & b ^ ab;
        ch = h & e ^ ~h & f;
        t1 = g + s1 + ch + K[j + 1] + blocks2[j + 1];
        t2 = s0 + maj;
        g = c + t1 << 0;
        c = t1 + t2 << 0;
        s0 = (c >>> 2 | c << 30) ^ (c >>> 13 | c << 19) ^ (c >>> 22 | c << 10);
        s1 = (g >>> 6 | g << 26) ^ (g >>> 11 | g << 21) ^ (g >>> 25 | g << 7);
        cd = c & d;
        maj = cd ^ c & a ^ da;
        ch = g & h ^ ~g & e;
        t1 = f + s1 + ch + K[j + 2] + blocks2[j + 2];
        t2 = s0 + maj;
        f = b + t1 << 0;
        b = t1 + t2 << 0;
        s0 = (b >>> 2 | b << 30) ^ (b >>> 13 | b << 19) ^ (b >>> 22 | b << 10);
        s1 = (f >>> 6 | f << 26) ^ (f >>> 11 | f << 21) ^ (f >>> 25 | f << 7);
        bc = b & c;
        maj = bc ^ b & d ^ cd;
        ch = f & g ^ ~f & h;
        t1 = e + s1 + ch + K[j + 3] + blocks2[j + 3];
        t2 = s0 + maj;
        e = a + t1 << 0;
        a = t1 + t2 << 0;
        this.chromeBugWorkAround = true;
      }
      this.h0 = this.h0 + a << 0;
      this.h1 = this.h1 + b << 0;
      this.h2 = this.h2 + c << 0;
      this.h3 = this.h3 + d << 0;
      this.h4 = this.h4 + e << 0;
      this.h5 = this.h5 + f << 0;
      this.h6 = this.h6 + g << 0;
      this.h7 = this.h7 + h << 0;
    };
    Sha256.prototype.hex = function() {
      this.finalize();
      var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
      var hex = HEX_CHARS[h0 >>> 28 & 15] + HEX_CHARS[h0 >>> 24 & 15] + HEX_CHARS[h0 >>> 20 & 15] + HEX_CHARS[h0 >>> 16 & 15] + HEX_CHARS[h0 >>> 12 & 15] + HEX_CHARS[h0 >>> 8 & 15] + HEX_CHARS[h0 >>> 4 & 15] + HEX_CHARS[h0 & 15] + HEX_CHARS[h1 >>> 28 & 15] + HEX_CHARS[h1 >>> 24 & 15] + HEX_CHARS[h1 >>> 20 & 15] + HEX_CHARS[h1 >>> 16 & 15] + HEX_CHARS[h1 >>> 12 & 15] + HEX_CHARS[h1 >>> 8 & 15] + HEX_CHARS[h1 >>> 4 & 15] + HEX_CHARS[h1 & 15] + HEX_CHARS[h2 >>> 28 & 15] + HEX_CHARS[h2 >>> 24 & 15] + HEX_CHARS[h2 >>> 20 & 15] + HEX_CHARS[h2 >>> 16 & 15] + HEX_CHARS[h2 >>> 12 & 15] + HEX_CHARS[h2 >>> 8 & 15] + HEX_CHARS[h2 >>> 4 & 15] + HEX_CHARS[h2 & 15] + HEX_CHARS[h3 >>> 28 & 15] + HEX_CHARS[h3 >>> 24 & 15] + HEX_CHARS[h3 >>> 20 & 15] + HEX_CHARS[h3 >>> 16 & 15] + HEX_CHARS[h3 >>> 12 & 15] + HEX_CHARS[h3 >>> 8 & 15] + HEX_CHARS[h3 >>> 4 & 15] + HEX_CHARS[h3 & 15] + HEX_CHARS[h4 >>> 28 & 15] + HEX_CHARS[h4 >>> 24 & 15] + HEX_CHARS[h4 >>> 20 & 15] + HEX_CHARS[h4 >>> 16 & 15] + HEX_CHARS[h4 >>> 12 & 15] + HEX_CHARS[h4 >>> 8 & 15] + HEX_CHARS[h4 >>> 4 & 15] + HEX_CHARS[h4 & 15] + HEX_CHARS[h5 >>> 28 & 15] + HEX_CHARS[h5 >>> 24 & 15] + HEX_CHARS[h5 >>> 20 & 15] + HEX_CHARS[h5 >>> 16 & 15] + HEX_CHARS[h5 >>> 12 & 15] + HEX_CHARS[h5 >>> 8 & 15] + HEX_CHARS[h5 >>> 4 & 15] + HEX_CHARS[h5 & 15] + HEX_CHARS[h6 >>> 28 & 15] + HEX_CHARS[h6 >>> 24 & 15] + HEX_CHARS[h6 >>> 20 & 15] + HEX_CHARS[h6 >>> 16 & 15] + HEX_CHARS[h6 >>> 12 & 15] + HEX_CHARS[h6 >>> 8 & 15] + HEX_CHARS[h6 >>> 4 & 15] + HEX_CHARS[h6 & 15];
      if (!this.is224) {
        hex += HEX_CHARS[h7 >>> 28 & 15] + HEX_CHARS[h7 >>> 24 & 15] + HEX_CHARS[h7 >>> 20 & 15] + HEX_CHARS[h7 >>> 16 & 15] + HEX_CHARS[h7 >>> 12 & 15] + HEX_CHARS[h7 >>> 8 & 15] + HEX_CHARS[h7 >>> 4 & 15] + HEX_CHARS[h7 & 15];
      }
      return hex;
    };
    Sha256.prototype.toString = Sha256.prototype.hex;
    Sha256.prototype.digest = function() {
      this.finalize();
      var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3, h4 = this.h4, h5 = this.h5, h6 = this.h6, h7 = this.h7;
      var arr = [
        h0 >>> 24 & 255,
        h0 >>> 16 & 255,
        h0 >>> 8 & 255,
        h0 & 255,
        h1 >>> 24 & 255,
        h1 >>> 16 & 255,
        h1 >>> 8 & 255,
        h1 & 255,
        h2 >>> 24 & 255,
        h2 >>> 16 & 255,
        h2 >>> 8 & 255,
        h2 & 255,
        h3 >>> 24 & 255,
        h3 >>> 16 & 255,
        h3 >>> 8 & 255,
        h3 & 255,
        h4 >>> 24 & 255,
        h4 >>> 16 & 255,
        h4 >>> 8 & 255,
        h4 & 255,
        h5 >>> 24 & 255,
        h5 >>> 16 & 255,
        h5 >>> 8 & 255,
        h5 & 255,
        h6 >>> 24 & 255,
        h6 >>> 16 & 255,
        h6 >>> 8 & 255,
        h6 & 255
      ];
      if (!this.is224) {
        arr.push(h7 >>> 24 & 255, h7 >>> 16 & 255, h7 >>> 8 & 255, h7 & 255);
      }
      return arr;
    };
    Sha256.prototype.array = Sha256.prototype.digest;
    Sha256.prototype.arrayBuffer = function() {
      this.finalize();
      var buffer = new ArrayBuffer(this.is224 ? 28 : 32);
      var dataView = new DataView(buffer);
      dataView.setUint32(0, this.h0);
      dataView.setUint32(4, this.h1);
      dataView.setUint32(8, this.h2);
      dataView.setUint32(12, this.h3);
      dataView.setUint32(16, this.h4);
      dataView.setUint32(20, this.h5);
      dataView.setUint32(24, this.h6);
      if (!this.is224) {
        dataView.setUint32(28, this.h7);
      }
      return buffer;
    };
    function HmacSha256(key, is224, sharedMemory) {
      var i, type = typeof key;
      if (type === "string") {
        var bytes = [], length = key.length, index = 0, code;
        for (i = 0; i < length; ++i) {
          code = key.charCodeAt(i);
          if (code < 128) {
            bytes[index++] = code;
          } else if (code < 2048) {
            bytes[index++] = 192 | code >>> 6;
            bytes[index++] = 128 | code & 63;
          } else if (code < 55296 || code >= 57344) {
            bytes[index++] = 224 | code >>> 12;
            bytes[index++] = 128 | code >>> 6 & 63;
            bytes[index++] = 128 | code & 63;
          } else {
            code = 65536 + ((code & 1023) << 10 | key.charCodeAt(++i) & 1023);
            bytes[index++] = 240 | code >>> 18;
            bytes[index++] = 128 | code >>> 12 & 63;
            bytes[index++] = 128 | code >>> 6 & 63;
            bytes[index++] = 128 | code & 63;
          }
        }
        key = bytes;
      } else {
        if (type === "object") {
          if (key === null) {
            throw new Error(ERROR);
          } else if (ARRAY_BUFFER && key.constructor === ArrayBuffer) {
            key = new Uint8Array(key);
          } else if (!Array.isArray(key)) {
            if (!ARRAY_BUFFER || !ArrayBuffer.isView(key)) {
              throw new Error(ERROR);
            }
          }
        } else {
          throw new Error(ERROR);
        }
      }
      if (key.length > 64) {
        key = new Sha256(is224, true).update(key).array();
      }
      var oKeyPad = [], iKeyPad = [];
      for (i = 0; i < 64; ++i) {
        var b = key[i] || 0;
        oKeyPad[i] = 92 ^ b;
        iKeyPad[i] = 54 ^ b;
      }
      Sha256.call(this, is224, sharedMemory);
      this.update(iKeyPad);
      this.oKeyPad = oKeyPad;
      this.inner = true;
      this.sharedMemory = sharedMemory;
    }
    HmacSha256.prototype = new Sha256();
    HmacSha256.prototype.finalize = function() {
      Sha256.prototype.finalize.call(this);
      if (this.inner) {
        this.inner = false;
        var innerHash = this.array();
        Sha256.call(this, this.is224, this.sharedMemory);
        this.update(this.oKeyPad);
        this.update(innerHash);
        Sha256.prototype.finalize.call(this);
      }
    };
    var exports = createMethod();
    exports.sha256 = exports;
    exports.sha224 = createMethod(true);
    exports.sha256.hmac = createHmacMethod();
    exports.sha224.hmac = createHmacMethod(true);
    if (COMMON_JS) {
      module.exports = exports;
    } else {
      root.sha256 = exports.sha256;
      root.sha224 = exports.sha224;
    }
  })();
})(sha256);
var sha256Exports = sha256.exports;
class PageLoad extends Component {
  async onInit() {
    this.els = [...document.querySelectorAll("[data-gtm-page-load]")];
    if (!this.els)
      return;
    this.shouldStop = false;
    const eventHandlers = {
      sign_up: this.handleSignup,
      login: this.handleLogin,
      newsletter_subscription: this.handleNewsletterSubscription,
      view_search_results: this.handleViewSearchResults,
      popin_change_website: this.handlePopinChangeWebsite
    };
    this.els.forEach((el) => {
      const elJson = el.querySelector(".js-gtm-json");
      this.json = elJson ? JSON.parse(elJson.textContent) : null;
      const event = this.json.event;
      const handler = eventHandlers[event];
      if (handler) {
        handler.call(this);
        if (this.shouldStop)
          return;
      }
      if (this.json == void 0) {
        this.onDestroy();
        return false;
      }
      if (window.dataLayer != void 0) {
        if (handler) {
          window.dataLayer.push({ ecommerce: null });
        }
        window.dataLayer.push(this.json);
      }
    });
  }
  handleSignup() {
    let isSignUp = localStorage.getItem("signup-attempt");
    if (!isSignUp) {
      this.shouldStop = true;
    } else {
      window.dataLayer.push(this.json);
      localStorage.removeItem("signup-attempt");
    }
  }
  handleLogin() {
    let isLogin = localStorage.getItem("login-attempt");
    if (!isLogin) {
      this.shouldStop = true;
    } else {
      localStorage.removeItem("login-attempt");
    }
  }
  handleNewsletterSubscription() {
    let isNl = localStorage.getItem("signNl-attempt");
    if (!isNl) {
      this.shouldStop = true;
    } else {
      if (this.json.hashed_256_email === "") {
        this.json = {
          ...this.json,
          hashed_256_email: sha256Exports.sha256(isNl)
        };
      }
      localStorage.removeItem("signNl-attempt");
    }
  }
  handleViewSearchResults() {
    let isSearchHandle = localStorage.getItem("search-handle");
    if (!isSearchHandle) {
      this.shouldStop = true;
    }
    localStorage.removeItem("search-handle");
  }
  handlePopinChangeWebsite() {
    let oldCountry = localStorage.getItem("country_status");
    if (!oldCountry) {
      this.shouldStop = true;
    } else {
      this.json = {
        ...this.json,
        country_change: `${oldCountry.split("_to_")[0]}_to_${this.json.country_change}`
      };
      localStorage.removeItem("country_status");
    }
  }
}
__publicField(PageLoad, "selectors", {
  el: "[data-gtm-page-load]"
});
const PageLoad$1 = new PageLoad();
class onClick extends Component {
  onInit(el) {
    this.el = el;
    const elJson = this.el.querySelector(".js-gtm-json");
    try {
      this.json = elJson && elJson.textContent ? JSON.parse(elJson.textContent) : null;
    } catch (error) {
      console.error("Erreur lors du parsing JSON :", error);
      this.json = null;
    }
    if (!this.json || this.json == void 0) {
      this.onDestroy();
      return false;
    }
    this.bindEvents();
  }
  bindEvents() {
    this.el.addEventListener("click", (e) => {
      if (this.json.event === "wishlist") {
        let selectedSize = document.querySelector("#size-selector [aria-activedescendant]");
        this.json = {
          ...this.json,
          item_size: (selectedSize == null ? void 0 : selectedSize.getAttribute("aria-activedescendant")) || ""
        };
      }
      if (this.json.event === "select_country") {
        localStorage.setItem("country_status", this.json.country_status);
      }
      if (window.dataLayer != void 0) {
        window.dataLayer.push(this.json);
      }
    });
  }
}
class ScrollInto extends Component {
  onInit() {
    this.elScrollContent = document.querySelector("[data-scroll-content]");
    if (history.scrollRestoration) {
      history.scrollRestoration = "manual";
    }
  }
  onReady() {
    const url = window.location.href;
    if (url.includes("/collections/")) {
      const hash = window.location.hash;
      if (hash)
        this.scrollInto(hash);
      else
        this.scrollToLastPosition();
    } else {
      this.scrollToLastPosition();
    }
  }
  scrollInto(hash) {
    if (hash) {
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ block: "start", inline: "nearest" });
        this.elScrollContent.scrollBy(0, -50);
        if (window.location.hash) {
          history.replaceState(null, "", window.location.pathname + window.location.search);
        }
      }
    }
  }
  scrollToLastPosition() {
    const scrollableElement = document.querySelector("[data-scroll-content]");
    const scrollKey = "scrollContentPosition";
    const currentPageKey = "currentPage";
    const previousPage = sessionStorage.getItem(currentPageKey);
    const currentPage = window.location.pathname + window.location.search;
    if (previousPage && previousPage !== currentPage) {
      sessionStorage.removeItem(scrollKey);
    }
    sessionStorage.setItem(currentPageKey, currentPage);
    if (!scrollableElement) {
      console.error("No element found with data-scroll-content");
      return;
    }
    const savedPosition = sessionStorage.getItem(scrollKey);
    if (savedPosition) {
      scrollableElement.scrollTop = parseInt(savedPosition, 10);
    }
    scrollableElement.addEventListener("scroll", () => {
      const scrollPosition = scrollableElement.scrollTop;
      sessionStorage.setItem(scrollKey, scrollPosition);
    });
  }
}
const ScrollInto$1 = new ScrollInto();
const ScrollInto$2 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ScrollInto$1
}, Symbol.toStringTag, { value: "Module" }));
window.addEventListener("load", () => {
  const heartAdd = document.querySelector(".js-product-heart-add");
  const heartRemove = document.querySelector(".js-product-heart-remove");
  const heartButton = document.querySelector(".swym-wishlist-button-bar");
  function toggleHeartDisplay(swymButton) {
    if (heartAdd && heartRemove) {
      if (swymButton.classList.contains("swym-added")) {
        heartAdd.classList.add("u-hidden");
        heartRemove.classList.remove("u-hidden");
      } else {
        heartAdd.classList.remove("u-hidden");
        heartRemove.classList.add("u-hidden");
      }
    }
  }
  function checkSwymButton() {
    const swymButton = document.querySelector(".swym-button");
    if (swymButton) {
      if (heartButton) {
        heartButton.style.display = "flex";
      }
      toggleHeartDisplay(swymButton);
      const classObserver = new MutationObserver(() => toggleHeartDisplay(swymButton));
      classObserver.observe(swymButton, { attributes: true, attributeFilter: ["class"] });
    }
  }
  setInterval(checkSwymButton, 500);
  setTimeout(() => {
    checkSwymButton();
  }, 100);
});
const observeHeartButton = () => {
  const targetNode = document.body;
  const config = { childList: true, subtree: true };
  const callback = (mutationsList, observer2) => {
    const heartButtonAdd = document.querySelector(".swym-add-to-wishlist");
    if (heartButtonAdd && !heartButtonAdd.hasAttribute("data-cnstrc-btn")) {
      heartButtonAdd.setAttribute("data-cnstrc-btn", "add_to_wishlist");
    }
  };
  const observer = new MutationObserver(callback);
  observer.observe(targetNode, config);
  callback();
};
observeHeartButton();
lazySizes.cfg.lazyClass = "lazyload";
lazySizes.cfg.init = true;
lazySizes.cfg.preloadAfterLoad = false;
lazySizes.cfg.loadMode = 1;
lazySizes.cfg.nativeLoading = {
  setLoadingAttribute: true,
  disableListeners: {
    focus: false,
    mouseover: false,
    click: false,
    load: false,
    transitionend: false,
    animationend: false,
    scroll: true,
    resize: true
  }
};
window.ClrzApp = {};
function ClrzAppInit() {
  ClrzApp.Screen = Screen;
  ClrzApp.ScrollInto = ScrollInto$1;
  ClrzApp.NotificationsManager = NotificationsManager$1;
  ClrzApp.WishlistNotification = WishlistNotification$1;
  ClrzApp.PageLoad = PageLoad$1;
  ClrzApp.Breadcrumb = Breadcrumb$1;
}
if (document.querySelector("[data-gtm-click]")) {
  const allGtmClick = [...document.querySelectorAll("[data-gtm-click]")];
  allGtmClick.forEach((el) => {
    new onClick(el);
  });
}
ClrzAppInit();
const islands = /* @__PURE__ */ Object.assign({ "../islands/AnnouncementBar.js": () => __vitePreload(() => import("./AnnouncementBar.min.c20a2983.js"), true ? ["./AnnouncementBar.min.c20a2983.js","./cssVar.min.a83b954d.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/CartDrawer.js": () => __vitePreload(() => import("./CartDrawer.min.60d88130.js"), true ? ["./CartDrawer.min.60d88130.js","./CartItems.min.29867f94.js"] : void 0, import.meta.url), "../islands/CartItems.js": () => __vitePreload(() => import("./CartItems.min.29867f94.js"), true ? [] : void 0, import.meta.url), "../islands/CartRemoveButton.js": () => __vitePreload(() => import("./CartRemoveButton.min.bb8c9c08.js"), true ? [] : void 0, import.meta.url), "../islands/CartSidebar.js": () => __vitePreload(() => import("./CartSidebar.min.cbb44d12.js"), true ? ["./CartSidebar.min.cbb44d12.js","./ClrzSidebar.min.9c600cca.js","./focusTrap.min.ee860a68.js","./getFocusables.min.247516ff.js","./Emitter.min.eb356be5.js","./FixScroll.min.9e4102b4.js","./Device.min.630865ee.js","./Component.min.06c3b4f2.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/ClrzPopin.js": () => __vitePreload(() => import("./ClrzPopin.min.096110bf.js"), true ? ["./ClrzPopin.min.096110bf.js","./focusTrap.min.ee860a68.js","./getFocusables.min.247516ff.js","./Emitter.min.eb356be5.js","./FixScroll.min.9e4102b4.js","./Device.min.630865ee.js","./Component.min.06c3b4f2.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/ClrzSelect.js": () => __vitePreload(() => import("./ClrzSelect.min.d4452162.js"), true ? ["./ClrzSelect.min.d4452162.js","./Emitter.min.eb356be5.js","./getAbsoluteOffset.min.af44d535.js","./Device.min.630865ee.js","./Component.min.06c3b4f2.js","./Screen.min.41307fbb.js","./cssVar.min.a83b954d.js","./FixScroll.min.9e4102b4.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/ClrzSidebar.js": () => __vitePreload(() => import("./ClrzSidebar.min.9c600cca.js"), true ? ["./ClrzSidebar.min.9c600cca.js","./focusTrap.min.ee860a68.js","./getFocusables.min.247516ff.js","./Emitter.min.eb356be5.js","./FixScroll.min.9e4102b4.js","./Device.min.630865ee.js","./Component.min.06c3b4f2.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/ClrzSlider.js": () => __vitePreload(() => import("./ClrzSlider.min.e9069242.js").then((n) => n.a), true ? ["./ClrzSlider.min.e9069242.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/DeloitteSlider.js": () => __vitePreload(() => import("./DeloitteSlider.min.f5cb0f0a.js"), true ? ["./DeloitteSlider.min.f5cb0f0a.js","./effect-fade.min.7f83cbf8.js","./DeferWebComponent.min.6ec788be.js","./DeloitteSlider.min.cc25d186.css"] : void 0, import.meta.url), "../islands/FacetFiltersForm.js": () => __vitePreload(() => import("./FacetFiltersForm.min.0541d653.js"), true ? ["./FacetFiltersForm.min.0541d653.js","./Emitter.min.eb356be5.js","./revive.min.03898b7d.js","./modulepreload-polyfill.min.7faf532e.js","./Screen.min.41307fbb.js","./Component.min.06c3b4f2.js","./cssVar.min.a83b954d.js","./Device.min.630865ee.js"] : void 0, import.meta.url), "../islands/FacetRemove.js": () => __vitePreload(() => import("./FacetRemove.min.c454fc3e.js"), true ? [] : void 0, import.meta.url), "../islands/GenderNavigation.js": () => __vitePreload(() => import("./GenderNavigation.min.0ea9f656.js"), true ? [] : void 0, import.meta.url), "../islands/GeoLocalization.js": () => __vitePreload(() => import("./GeoLocalization.min.a800451a.js"), true ? ["./GeoLocalization.min.a800451a.js","./DeferWebComponent.min.6ec788be.js","./Emitter.min.eb356be5.js"] : void 0, import.meta.url), "../islands/GmapsAutocomplete.js": () => __vitePreload(() => import("./GmapsAutocomplete.min.8d2b3ef3.js"), true ? ["./GmapsAutocomplete.min.8d2b3ef3.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/InputDate.js": () => __vitePreload(() => import("./InputDate.min.b2bb8dd5.js"), true ? ["./InputDate.min.b2bb8dd5.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/LocalizationForm.js": () => __vitePreload(() => import("./LocalizationForm.min.00a5e673.js"), true ? ["./LocalizationForm.min.00a5e673.js","./Emitter.min.eb356be5.js","./creator.min.6ca71758.js","./SearchIntoDOM.min.725f94a8.js","./Component.min.06c3b4f2.js","./Expandable.min.04a8d11d.js","./getFocusables.min.247516ff.js","./revive.min.03898b7d.js","./modulepreload-polyfill.min.7faf532e.js","./Screen.min.41307fbb.js","./cssVar.min.a83b954d.js","./Device.min.630865ee.js"] : void 0, import.meta.url), "../islands/NewsletterForm.js": () => __vitePreload(() => import("./NewsletterForm.min.edbcab18.js"), true ? ["./NewsletterForm.min.edbcab18.js","./_newsletter-form.min.89f0bdd9.css"] : void 0, import.meta.url), "../islands/NewsletterPopin.js": () => __vitePreload(() => import("./NewsletterPopin.min.6fe1e6b8.js"), true ? ["./NewsletterPopin.min.6fe1e6b8.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/NewsletterPopinAbtasty.js": () => __vitePreload(() => import("./NewsletterPopinAbtasty.min.c42675cd.js"), true ? ["./NewsletterPopinAbtasty.min.c42675cd.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/OrderTracking.js": () => __vitePreload(() => import("./OrderTracking.min.d7644fe2.js"), true ? ["./OrderTracking.min.d7644fe2.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/PlayerVideo.js": () => __vitePreload(() => import("./PlayerVideo.min.fa461448.js"), true ? ["./PlayerVideo.min.fa461448.js","./Observer.min.80767135.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/PredictiveSearch.js": () => __vitePreload(() => import("./PredictiveSearch.min.805883dc.js"), true ? ["./PredictiveSearch.min.805883dc.js","./Emitter.min.eb356be5.js"] : void 0, import.meta.url), "../islands/ProductForm.js": () => __vitePreload(() => import("./ProductForm.min.975a1d35.js"), true ? ["./ProductForm.min.975a1d35.js","./Emitter.min.eb356be5.js","./cssVar.min.a83b954d.js","./revive.min.03898b7d.js","./modulepreload-polyfill.min.7faf532e.js","./Screen.min.41307fbb.js","./Component.min.06c3b4f2.js","./Device.min.630865ee.js"] : void 0, import.meta.url), "../islands/SizeGuideWishlist.js": () => __vitePreload(() => import("./SizeGuideWishlist.min.3639f19f.js"), true ? ["./SizeGuideWishlist.min.3639f19f.js","./revive.min.03898b7d.js","./DeferWebComponent.min.6ec788be.js","./Emitter.min.eb356be5.js"] : void 0, import.meta.url), "../islands/SkipLink.js": () => __vitePreload(() => import("./SkipLink.min.2de78e69.js"), true ? ["./SkipLink.min.2de78e69.js","./getFocusables.min.247516ff.js"] : void 0, import.meta.url), "../islands/SwymWishlist.js": () => __vitePreload(() => import("./SwymWishlist.min.aeef6c60.js"), true ? ["./SwymWishlist.min.aeef6c60.js","./revive.min.03898b7d.js","./modulepreload-polyfill.min.7faf532e.js","./Screen.min.41307fbb.js","./Component.min.06c3b4f2.js","./cssVar.min.a83b954d.js","./Emitter.min.eb356be5.js","./Device.min.630865ee.js"] : void 0, import.meta.url), "../islands/VimeoPlayer.js": () => __vitePreload(() => import("./VimeoPlayer.min.77527755.js"), true ? ["./VimeoPlayer.min.77527755.js","./VimeoRegister.min.81ebd55a.js","./Observer.min.80767135.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/YoutubePlayer.js": () => __vitePreload(() => import("./YoutubePlayer.min.c2560a02.js"), true ? ["./YoutubePlayer.min.c2560a02.js","./YoutubeRegister.min.3890dccc.js","./Observer.min.80767135.js","./DeferWebComponent.min.6ec788be.js"] : void 0, import.meta.url), "../islands/newsletter-form-abtasty.js": () => __vitePreload(() => import("./newsletter-form-abtasty.min.7b305c29.js"), true ? [] : void 0, import.meta.url) });
for (let island in islands) {
  revive(island, islands);
}
const components = /* @__PURE__ */ Object.assign({
  "../components/Breadcrumb.js": () => __vitePreload(() => Promise.resolve().then(() => Breadcrumb$2), true ? void 0 : void 0, import.meta.url),
  "../components/Cart.js": () => __vitePreload(() => import("./Cart.min.a0cf21a4.js"), true ? ["./Cart.min.a0cf21a4.js","./Component.min.06c3b4f2.js"] : void 0, import.meta.url),
  "../components/CartCounter.js": () => __vitePreload(() => Promise.resolve().then(() => CartCounter$1), true ? void 0 : void 0, import.meta.url),
  "../components/CartNotification.js": () => __vitePreload(() => Promise.resolve().then(() => CartNotification$1), true ? void 0 : void 0, import.meta.url),
  "../components/CustomerAddresses.js": () => __vitePreload(() => import("./CustomerAddresses.min.8d809ce1.js"), true ? [] : void 0, import.meta.url),
  "../components/DisableZoomIos.js": () => __vitePreload(() => import("./DisableZoomIos.min.20bbd1f6.js"), true ? ["./DisableZoomIos.min.20bbd1f6.js","./Component.min.06c3b4f2.js","./Device.min.630865ee.js"] : void 0, import.meta.url),
  "../components/Expandable.js": () => __vitePreload(() => import("./Expandable.min.04a8d11d.js"), true ? ["./Expandable.min.04a8d11d.js","./Component.min.06c3b4f2.js","./Emitter.min.eb356be5.js","./getFocusables.min.247516ff.js"] : void 0, import.meta.url),
  "../components/FooterExpandable.js": () => __vitePreload(() => import("./FooterExpandable.min.ba4e996f.js"), true ? ["./FooterExpandable.min.ba4e996f.js","./Component.min.06c3b4f2.js","./Emitter.min.eb356be5.js","./getFocusables.min.247516ff.js"] : void 0, import.meta.url),
  "../components/Form/FormValidations.js": () => __vitePreload(() => import("./FormValidations.min.33723d1f.js"), true ? ["./FormValidations.min.33723d1f.js","./Component.min.06c3b4f2.js","./revive.min.03898b7d.js"] : void 0, import.meta.url),
  "../components/GenderPicture.js": () => __vitePreload(() => import("./GenderPicture.min.23559546.js"), true ? ["./GenderPicture.min.23559546.js","./Component.min.06c3b4f2.js"] : void 0, import.meta.url),
  "../components/Header/Header.js": () => __vitePreload(() => import("./Header.min.b4b1178b.js"), true ? ["./Header.min.b4b1178b.js","./revive.min.03898b7d.js","./getFocusables.min.247516ff.js","./focusTrap.min.ee860a68.js","./Component.min.06c3b4f2.js","./creator.min.6ca71758.js","./Emitter.min.eb356be5.js","./Screen.min.41307fbb.js","./cssVar.min.a83b954d.js","./FixScroll.min.9e4102b4.js","./Device.min.630865ee.js","./getAbsoluteOffset.min.af44d535.js"] : void 0, import.meta.url),
  "../components/OrderReturn.js": () => __vitePreload(() => import("./OrderReturn.min.0dfbce8d.js"), true ? ["./OrderReturn.min.0dfbce8d.js","./Component.min.06c3b4f2.js","./FormValidations.min.33723d1f.js","./revive.min.03898b7d.js","./creator.min.6ca71758.js"] : void 0, import.meta.url),
  "../components/OrderTracking.js": () => __vitePreload(() => import("./OrderTracking.min.bfd2847c.js"), true ? ["./OrderTracking.min.bfd2847c.js","./Component.min.06c3b4f2.js","./FormValidations.min.33723d1f.js","./revive.min.03898b7d.js","./creator.min.6ca71758.js"] : void 0, import.meta.url),
  "../components/Password.js": () => __vitePreload(() => import("./Password.min.e78644e1.js"), true ? ["./Password.min.e78644e1.js","./Component.min.06c3b4f2.js"] : void 0, import.meta.url),
  "../components/PersonalInfos.js": () => __vitePreload(() => import("./PersonalInfos.min.ccfbf64a.js"), true ? ["./PersonalInfos.min.ccfbf64a.js","./Component.min.06c3b4f2.js","./FormValidations.min.33723d1f.js","./revive.min.03898b7d.js","./creator.min.6ca71758.js"] : void 0, import.meta.url),
  "../components/RegisterLogin.js": () => __vitePreload(() => import("./RegisterLogin.min.ee7c8e8c.js"), true ? ["./RegisterLogin.min.ee7c8e8c.js","./Component.min.06c3b4f2.js","./creator.min.6ca71758.js","./Tabs.min.2df6e62e.js","./Emitter.min.eb356be5.js","./FormValidations.min.33723d1f.js","./revive.min.03898b7d.js"] : void 0, import.meta.url),
  "../components/ScrollInto.js": () => __vitePreload(() => Promise.resolve().then(() => ScrollInto$2), true ? void 0 : void 0, import.meta.url),
  "../components/SearchIntoDOM.js": () => __vitePreload(() => import("./SearchIntoDOM.min.725f94a8.js"), true ? ["./SearchIntoDOM.min.725f94a8.js","./Component.min.06c3b4f2.js","./creator.min.6ca71758.js","./Expandable.min.04a8d11d.js","./Emitter.min.eb356be5.js","./getFocusables.min.247516ff.js"] : void 0, import.meta.url),
  "../components/Sticky.js": () => __vitePreload(() => import("./Sticky.min.107880ea.js"), true ? ["./Sticky.min.107880ea.js","./Component.min.06c3b4f2.js","./Device.min.630865ee.js","./index.min.911bcf3b.js","./Observer.min.80767135.js"] : void 0, import.meta.url),
  "../components/Tabs.js": () => __vitePreload(() => import("./Tabs.min.2df6e62e.js"), true ? ["./Tabs.min.2df6e62e.js","./Component.min.06c3b4f2.js","./Emitter.min.eb356be5.js"] : void 0, import.meta.url),
  "../components/TextareaFitContent.js": () => __vitePreload(() => import("./TextareaFitContent.min.0cc17cc7.js"), true ? ["./TextareaFitContent.min.0cc17cc7.js","./Component.min.06c3b4f2.js","./index.min.911bcf3b.js","./Emitter.min.eb356be5.js"] : void 0, import.meta.url),
  "../components/Topic.js": () => __vitePreload(() => import("./Topic.min.7574b013.js"), true ? ["./Topic.min.7574b013.js","./Expandable.min.04a8d11d.js","./Component.min.06c3b4f2.js","./Emitter.min.eb356be5.js","./getFocusables.min.247516ff.js"] : void 0, import.meta.url),
  "../components/VimeoRegister.js": () => __vitePreload(() => import("./VimeoRegister.min.81ebd55a.js"), true ? [] : void 0, import.meta.url),
  "../components/YoutubeRegister.js": () => __vitePreload(() => import("./YoutubeRegister.min.3890dccc.js"), true ? [] : void 0, import.meta.url)
});
for (let component in components) {
  revive(component, components, true);
}
const incrPageViewed = () => {
  let pageViewed = sessionStorage.getItem("page_viewed");
  if (document.body.classList.contains("template-index")) {
    pageViewed = pageViewed ? parseInt(pageViewed) : 1;
  } else {
    pageViewed = pageViewed ? parseInt(pageViewed) + 1 : 1;
  }
  sessionStorage.setItem("page_viewed", pageViewed);
};
incrPageViewed();
export {
  CartNotification as C,
  CartCounter as a,
  getDefaultExportFromCjs as g,
  onClick as o
};
